{
  "actividades": {
    "actionActivate": "Activar",
    "actionDeactivate": "Desactivar",
    "actionDelete": "Eliminar",
    "actionEdit": "Editar",
    "bannerCreated": "Actividad creada correctamente.",
    "bannerDeleted": "Actividad eliminada.",
    "bannerUpdated": "Actividad actualizada correctamente.",
    "buttonCancel": "Cancelar",
    "buttonCreate": "Crear actividad",
    "buttonSave": "Guardar cambios",
    "buttonUpdate": "Actualizar actividad",
    "confirmDelete": "¿Seguro que deseas eliminar la actividad \"{{name}}\"?",
    "currencies": {
      "ARS": "Peso argentino",
      "BRL": "Real brasileño",
      "CAD": "Dólar canadiense",
      "CLP": "Peso chileno",
      "COP": "Peso colombiano",
      "EUR": "Euro",
      "GBP": "Libra esterlina",
      "LOCAL": "Moneda local",
      "MXN": "Peso mexicano",
      "PEN": "Sol peruano",
      "USD": "Dólar estadounidense"
    },
    "empty": "No hay actividades registradas.",
    "errorDelete": "No se pudo eliminar la actividad.",
    "errorLoad": "Error al cargar las actividades.",
    "errorMissingCurrency": "La moneda es obligatoria.",
    "errorMissingName": "El nombre de la actividad es obligatorio.",
    "errorMissingRate": "La tarifa por hora es obligatoria.",
    "errorMissingTenant": "No se encontró la organización del usuario (tenant_id/org_id).",
    "errorNameRequired": "El nombre de la actividad es obligatorio.",
    "errorRatePositive": "La tarifa por hora debe ser mayor que 0.",
    "errorSave": "No se pudo guardar la actividad.",
    "errorToggle": "No se pudo cambiar el estado de la actividad.",
    "fieldCurrency": "Moneda",
    "fieldDescription": "Descripción",
    "fieldDescriptionPlaceholder": "Descripción breve de la actividad…",
    "fieldHourlyRate": "Tarifa por hora",
    "fieldHourlyRatePlaceholder": "Ej. 3.50",
    "fieldName": "Nombre de la actividad",
    "fieldNamePlaceholder": "Ej. Siembra, Riego, Cosecha",
    "formTitleEdit": "Editar actividad",
    "formTitleNew": "Nueva actividad",
    "loading": "Cargando actividades…",
    "goDashboard": "Ir al panel",
    "readOnlyNote": "Solo el propietario y los administradores pueden crear o editar actividades.",
    "statusActive": "Activa",
    "statusInactive": "Inactiva",
    "tableNoResults": "No hay actividades registradas.",
    "tableTitle": "Listado de actividades",
    "thActions": "Acciones",
    "thCost": "Costo",
    "thDescription": "Descripción",
    "thName": "Actividad",
    "thStatus": "Estado",
    "title": "Actividades"
  },
  "admins": {
    "actions": {
      "makeAdmin": "Convertir en admin",
      "makeOwner": "Convertir en propietario",
      "remove": "Eliminar acceso"
    },
    "banner": {
      "invitationSent": "Invitación enviada correctamente.",
      "removed": "Administrador eliminado de la organización.",
      "roleUpdated": "Rol actualizado."
    },
    "error": {
      "invite": "No se pudo enviar la invitación.",
      "load": "Error al cargar la lista de administradores.",
      "remove": "No se pudo eliminar al administrador.",
      "updateRole": "No se pudo actualizar el rol."
    },
    "form": {
      "buttonInvite": "Enviar invitación",
      "emailLabel": "Correo electrónico",
      "inviteTitle": "Invitar nuevo administrador",
      "roleLabel": "Rol"
    },
    "subtitle": "Gestiona los administradores de tu organización y sus roles.",
    "table": {
      "actions": "Acciones",
      "email": "Correo electrónico",
      "name": "Nombre",
      "noResults": "No hay administradores registrados.",
      "role": "Rol",
      "status": "Estado"
    },
    "title": "Administradores"
  },
  "app": {
    "brand": "GeoField GPS",
    "header": {
      "goToPanel": "Ir al panel",
      "loggedAs": "Sesión iniciada como",
      "login": "Iniciar sesión",
      "loginMagic": "Link mágico",
      "logout": "Salir",
      "organizationAriaLabel": "Seleccionar organización",
      "organizationLabel": "Organización",
      "organizationNone": "Sin organización",
      "roleAdmin": "Administrador",
      "roleOwner": "Propietario",
      "roleTracker": "Tracker"
    },
    "tabs": {
      "actividades": "Actividades",
      "admins": "Administrador",
      "asignaciones": "Asignaciones",
      "planificacion": "Planificación",
      "dashboard": "Panel de costos",
      "dashboardCostos": "Panel de costos",
      "panelCostos": "Panel de costos",
      "geocerca": "Geocerca",
      "geocercas": "Geocercas",
      "home": "Inicio",
      "inicio": "Inicio",
      "invitar_tracker": "Invitar tracker",
      "invitarTracker": "Invitar tracker",
      "nuevaGeocerca": "Geocerca",
      "personal": "Personal",
      "pricing": "Pricing",
      "reportes": "Reportes",
      "billing": "Billing",
      "tracker": "Tracker",
      "resources": "Recursos",
      "benchmarking": "Benchmarking",
      "incidents": "Incidencias"
    },
    "title": "GeoField GPS"
  },
  "onboardingCreateOrg": {
    "title": "Crea tu organización",
    "body": "Crea el espacio de trabajo de tu empresa para empezar a supervisar tu equipo de campo.",
    "nameLabel": "Nombre de la organización",
    "namePlaceholder": "Ej: Mi Empresa",
    "submit": "Crear mi organización",
    "creating": "Creando…",
    "alreadyActive": "Ya tienes una organización activa.",
    "loginRequired": "Debes iniciar sesión.",
    "nameRequired": "Escribe el nombre de tu organización.",
    "createdRedirecting": "Organización creada. Redirigiendo…",
    "limitReached": "Ya tienes una organización creada. Puedes cambiar de organización o contactar soporte para crear una organización adicional.",
    "createFailed": "No se pudo crear la organización."
  },
  "asignaciones": {
    "actions": {
      "activate": "Activar",
      "deactivate": "Desactivar",
      "delete": "Eliminar",
      "edit": "Editar",
      "save": "Guardar asignación",
      "update": "Actualizar asignación",
      "cancel": "Cancelar"
    },
    "banner": {
      "created": "Asignación creada correctamente.",
      "deleted": "Asignación eliminada.",
      "updated": "Asignación actualizada."
    },
    "error": {
      "delete": "No se pudo eliminar la asignación.",
      "endBeforeStart": "La fecha/hora de fin no puede ser anterior a la fecha/hora de inicio.",
      "invalidFrequency": "La frecuencia debe ser de al menos 5 minutos.",
      "invalidPerson": "Debe seleccionar una persona válida.",
      "load": "Error al cargar las asignaciones.",
      "missingActivity": "Debe seleccionar una actividad.",
      "missingEnd": "Debe ingresar fecha/hora de fin.",
      "missingGeofence": "Debe seleccionar una geocerca.",
      "noActiveOrg": "No hay organización activa.",
      "personMissingUserId": "La persona seleccionada no tiene user_id. No se puede vincular como tracker.",
      "missingPerson": "Debe seleccionar una persona.",
      "missingStart": "Debe ingresar fecha/hora de inicio.",
      "save": "No se pudo guardar la asignación.",
      "update": "Error al actualizar asignación."
    },
    "filters": {
      "refresh": "Refrescar",
      "refreshLoading": "Actualizando…",
      "status": {
        "activo": "Activos",
        "inactivo": "Inactivos",
        "todos": "Todos"
      },
      "statusLabel": "Estado",
      "searchPlaceholder": "Buscar (persona/geocerca)",
      "statusDefault": "Estado: todos",
      "statusAll": "Estado: todos",
      "geofenceAll": "Geocerca: todas",
      "personalAll": "Personal: todos"
    },
    "fields": {
      "person": "Persona",
      "geofence": "Geocerca",
      "activity": "Actividad",
      "startAt": "Fecha/hora inicio",
      "endAt": "Fecha/hora fin",
      "status": "Estado",
      "frequencyMinutes": "Frecuencia (minutos)"
    },
    "statusOptions": {
      "active": "Activa"
    },
    "form": {
      "activityLabel": "Actividad",
      "activityPlaceholder": "Selecciona una actividad",
      "select": "Seleccionar",
      "buttonCancel": "Cancelar",
      "buttonCreate": "Crear asignación",
      "buttonUpdate": "Actualizar asignación",
      "cancelEditButton": "Cancelar edición",
      "editTitle": "Editar asignación",
      "endLabel": "Fecha/hora fin",
      "endOptionalHint": "Opcional",
      "frequencyLabel": "Frecuencia (minutos)",
      "geofenceLabel": "Geocerca",
      "geofencePlaceholder": "Selecciona una geocerca",
      "newTitle": "Nueva asignación",
      "personLabel": "Persona",
      "personPlaceholder": "Selecciona una persona",
      "quickActivity": {
        "newButton": "Nueva actividad",
        "newNamePlaceholder": "Nombre de la nueva actividad",
        "noActivitiesHint": "No hay actividades (cree una en el módulo Actividades o aquí abajo).",
        "saveButton": "Guardar actividad",
        "saving": "Guardando…"
      },
      "saveButton": "Guardar asignación",
      "startLabel": "Fecha/hora inicio",
      "statusActive": "Activa",
      "statusInactive": "Inactiva",
      "statusLabel": "Estado",
      "updateButton": "Actualizar asignación",
      "newActivityPlaceholder": "Nombre de la nueva actividad",
      "saveActivityButton": "Guardar actividad",
      "savingActivity": "Guardando…",
      "cancelButton": "Cancelar",
      "startDateLabel": "Fecha inicio",
      "startDatePlaceholder": "DD/MM/AAAA HH:MM o 2025-11-13T09:11",
      "endDateLabel": "Fecha fin (opcional)",
      "endDatePlaceholder": "DD/MM/AAAA HH:MM o 2025-11-14T19:17",
      "activityOptional": "(Opcional) Seleccione…",
      "createButtonLabel": "Crear asignación"
    },
    "messages": {
      "catalogError": "Error al cargar catálogos (personal, geocercas, actividades).",
      "confirmDelete": "¿Seguro que deseas eliminar esta asignación?",
      "createGenericError": "No se pudo crear la asignación.",
      "createSuccess": "Asignación creada correctamente.",
      "deleteError": "No se pudo eliminar la asignación.",
      "deleteSuccess": "Asignación eliminada correctamente.",
      "activatedSuccess": "Asignación activada correctamente.",
      "deactivatedSuccess": "Asignación desactivada correctamente.",
      "toggleStatusError": "Error al cambiar estado de asignación.",
      "frequencyInvalidRange": "La frecuencia debe estar entre 5 minutos y 12 horas.",
      "frequencyTooLow": "La frecuencia mínima permitida es de 5 minutos.",
      "loadError": "Error al cargar las asignaciones.",
      "loadingData": "Cargando datos de asignaciones…",
      "noActivities": "No hay actividades creadas. Crea al menos una Actividad para poder asignar.",
      "noPersonal": "No hay personal vigente en esta organización. Reactiva o crea al menos una persona.",
      "overlapError": "La persona ya tiene una asignación activa que se solapa en ese rango de fechas.",
      "saveGenericError": "Ocurrió un error al guardar la asignación.",
      "selectDates": "Debes ingresar fecha y hora de inicio y de fin.",
      "selectPersonAndFence": "Debes seleccionar una persona y una geocerca.",
      "updateGenericError": "No se pudo actualizar la asignación.",
      "updateSuccess": "Asignación actualizada correctamente."
    },
    "table": {
      "actions": "Acciones",
      "activity": "Actividad",
      "end": "Fin",
      "frequency": "Freq (min)",
      "geofence": "Geocerca",
      "noResults": "No hay asignaciones registradas.",
      "person": "Persona",
      "start": "Inicio",
      "status": "Estado",
      "title": "Listado de asignaciones"
    },
    "title": "Asignaciones",
    "states": {
      "all": "todos",
      "active": "activa",
      "inactive": "inactiva"
    }
  },
  "auth": {
    "backToLogin": "Volver a iniciar sesión",
    "errorTitle": "No se pudo autenticar",
    "invalidOrExpiredLink": "El enlace es inválido, ya expiró o fue utilizado.",
    "processing": "Autenticando…",
    "timeout": "La autenticación tardó demasiado. Intenta nuevamente.",
    "selection": {
      "title": "Seleccionar organización",
      "loading": "Cargando organizaciones asociadas a tu usuario...",
      "invalidSessionTitle": "Sesión no válida",
      "invalidSessionBody": "No hay sesión activa. Inicia sesión nuevamente.",
      "noOrganizationsBody": "Has iniciado sesión correctamente, pero no encontramos organizaciones asociadas a tu usuario.",
      "noOrganizationsHelp": "Contacta al administrador para que te asigne una organización o crea una nueva desde el panel de administración.",
      "subtitle": "Has iniciado sesión correctamente. Ahora elige la organización con la que deseas trabajar en este momento.",
      "noName": "(sin nombre)",
      "code": "Código: {{code}}",
      "noCode": "Sin código definido"
    },
    "requireOrg": {
      "loading": "Cargando tu sesión y organización actual...",
      "resolvingOrganization": "Resolviendo tu organización..."
    },
    "callback": {
      "title": "Auth Callback",
      "invalidLinkTitle": "El enlace de acceso ya no es válido",
      "invalidLinkDetail": "Esto pasa si el enlace expiró o si fue abierto o escaneado antes, por ejemplo por una previsualización del correo o si se abrió dos veces.",
      "invalidLinkTipLatest": "Usa el correo más reciente y ábrelo solo una vez.",
      "invalidLinkTipBrowser": "Evita abrirlo dentro de un navegador interno del correo. Si puedes, usa Abrir en Chrome.",
      "invalidLinkTipOwner": "Si vuelve a fallar, pide al Owner que reenvíe la invitación.",
      "loginFailedTitle": "No se pudo completar el login",
      "loginFailedDetail": "No se pudo establecer la sesión desde el callback. Esto suele ocurrir si el enlace fue consumido, expiró o fue procesado con el cliente incorrecto.",
      "loginFailedTipRetry": "Reintenta con un enlace nuevo.",
      "loginFailedTipDevice": "Abre el enlace en el mismo dispositivo donde lo recibiste.",
      "confirmingSession": "Confirmando sesión…",
      "exchangingCode": "Intercambiando código…",
      "restoringSession": "Restaurando sesión…",
      "noSessionFromCallback": "No se pudo establecer sesión desde el callback.",
      "creatingSecureCookies": "Creando cookies seguras…",
      "redirecting": "Redirigiendo…"
    },
    "signup": {
      "title": "Crea tu cuenta gratis",
      "subtitle": "Empieza a supervisar tu equipo de campo con GeoField GPS.",
      "labels": {
        "fullName": "Nombre completo (opcional)",
        "email": "Correo"
      },
      "placeholders": {
        "fullName": "Tu nombre",
        "email": "tucorreo@dominio.com"
      },
      "buttons": {
        "creating": "Enviando...",
        "create": "Crear cuenta gratis"
      },
      "errors": {
        "invalidEmail": "Ingresa un correo válido.",
        "mustAcceptTerms": "Debes aceptar los Términos y la Política de Privacidad.",
        "sendFailed": "No se pudo enviar el Magic Link: {{message}}",
        "unknown": "Error desconocido{{#if message}}: {{message}}{{/if}}",
        "googleFailed": "No se pudo iniciar con Google: {{message}}",
        "googleNoUrl": "No se obtuvo URL de redirección de Google.",
        "googleUnknown": "Error desconocido con Google OAuth{{#if message}}: {{message}}{{/if}}"
      },
      "messages": {
        "magicLinkSent": "Te enviamos un enlace seguro. Revisa tu correo y ábrelo para confirmar tu cuenta."
      },
      "terms": {
        "acceptance": "Acepto los",
        "terms": "Términos",
        "and": "y la",
        "privacy": "Política de Privacidad"
      },
      "alreadyHaveAccount": "¿Ya tienes cuenta?",
      "loginLink": "Inicia sesión",
      "separator": "o",
      "oauthGoogle": "Registrarse con Google"
    }
  },
  "authInvite": {
    "continue": "Continuar",
    "expiredOrUsed": "La invitación es inválida, ya expiró o fue utilizada.",
    "goToLogin": "Ir a iniciar sesión",
    "notInviteLink": "Este enlace no es una invitación válida. Usa el enlace de invitación que recibiste por correo.",
    "processing": "Validando invitación…",
    "timeout": "La validación de la invitación tardó demasiado. Intenta nuevamente.",
    "title": "Has sido invitado"
  },
  "accountPage": {
    "title": "Cuenta",
    "loading": "Cargando cuenta...",
    "noActiveSession": "No hay sesión activa",
    "sessionStatus": "Estado de sesión",
    "user": "Usuario",
    "currentOrganization": "Organización actual",
    "role": "Rol",
    "noSignOutAction": "No hay acción de cierre de sesión disponible en el contexto actual."
  },
  "errors": {
    "notAuthorized": {
      "title": "Acceso denegado",
      "body": "No tienes permisos para acceder a esta sección. Contacta al administrador si crees que es un error."
    }
  },
  "common": {
    "actions": {
      "back": "Volver",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "delete": "Eliminar",
      "edit": "Editar",
      "installApp": "Instalar app",
      "loading": "Cargando...",
      "no": "No",
      "logout": "Cerrar sesión",
      "openApp": "Abrir app",
      "processing": "Saliendo...",
      "retry": "Reintentar",
      "save": "Guardar",
      "yes": "Sí"
    },
    "back": "Volver",
    "createOrganization": "Crear organización",
    "fallbacks": {
      "noAuth": "No autenticado",
      "noEmail": "Sin correo",
      "noOrg": "Sin organización"
    },
    "language": {
      "en": "Inglés",
      "es": "Español",
      "fr": "Francés"
    },
    "orgNamePlaceholder": "Nombre de la organización (ej. Finca A)",
    "refreshContext": "Refrescar contexto",
    "roles": {
      "noRole": "SIN ROL",
      "root": "ROOT"
    },
    "select": "Seleccionar",
    "sending": "Enviando...",
    "show": "Mostrar",
    "hide": "Ocultar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "loading": "Cargando",
    "search": "Buscar",
    "noResults": "Sin resultados",
    "separator": "—",
    "zoom": "Zoom",
    "refresh": "Actualizar",
    "ok": "OK",
    "openArrow": "Abrir →",
    "debug": "Depuración",
    "pagination": {
      "pageOf": "Página {{page}} de {{total}}",
      "prev": "Anterior",
      "next": "Siguiente"
    },
    "states": {
      "pending": "Pendiente",
      "visible": "Visible",
      "hidden": "Oculta"
    }
  },
  "dashboard": {
    "welcome": "Bienvenido a GeoField GPS",
    "sessionAs": "Sesión iniciada como {{role}}",
    "email": "Correo",
    "organizationId": "Organización ID",
    "goToDashboard": "Ir al panel",
    "managePlan": "Administrar plan",
    "subscribePro": "Suscribirme a PRO",
    "deleteAccount": "Eliminar cuenta",
    "helpCenter": "Centro de ayuda",
    "help": {
      "quickGuide": {
        "title": "Guía rápida",
        "desc": "Aprende cómo usar la app paso a paso."
      },
      "faq": {
        "title": "Preguntas frecuentes",
        "desc": "Respuestas a las dudas más comunes."
      },
      "support": {
        "title": "Soporte",
        "desc": "¿Tienes un problema o consulta? Contáctanos."
      },
      "updates": {
        "title": "Novedades",
        "desc": "Cambios, mejoras y actualizaciones recientes."
      }
    },
    "adminPanel": {
      "title": "Panel de Administración",
      "description": "Gestione usuarios, roles y organizaciones desde aquí.",
      "sections": {
        "users": "Usuarios",
        "roles": "Roles",
        "organizations": "Organizaciones"
      },
      "columns": {
        "name": "Nombre",
        "email": "Email",
        "role": "Rol",
        "createdAt": "Fecha Creación",
        "description": "Descripción"
      }
    },
    "adminTools": {
      "title": "Herramientas de administrador",
      "protectedPanel": "Selecciona un módulo para administrar tu app. Este panel está protegido para usuarios con rol owner o admin."
    },
    "administracion": {
      "title": "Administración"
    },
    "adminReportes": {
      "title": "Reportes"
    },
    "cards": {
      "totalCost": "Costo total",
      "totalGeofences": "Geocercas",
      "totalHours": "Horas totales",
      "totalPersons": "Personas"
    },
    "charts": {
      "costByActivity": "Costo por actividad",
      "costByGeofence": "Costo por geocerca",
      "costByPerson": "Costo por persona",
      "hoursByDay": "Horas por día"
    },
    "errorLoad": "Error al cargar el panel de costos.",
    "filters": {
      "apply": "Aplicar",
      "clear": "Limpiar",
      "dateFromLabel": "Desde",
      "dateToLabel": "Hasta"
    },
    "subtitle": "Visualiza los costos agregados por persona, actividad y geocerca.",
    "title": "panel de costos",
    "currentPlan": "Plan actual",
    "maxPlanEnterprise": "Tu organización ya tiene el plan máximo (Enterprise).",
    "subscribeEnterprise": "Suscribirme a Enterprise"
  },
  "dashboardCostos": {
    "title": "Panel de costos",
    "subtitle": "Visualiza KPIs y gráficos de costos por persona, actividad y geocerca.",
    "currentOrganization": "Organización actual",
    "actions": {
      "refresh": "Refrescar datos",
      "exportData": "Exportar datos",
      "exportGraphic": "Exportar gráfico"
    },
    "kpis": {
      "totalHours": "Horas totales",
      "totalCost": "Costo total",
      "registrations": "Registros",
      "avgRate": "Tarifa promedio"
    },
    "errors": {
      "invalidAction": "Acción inválida",
      "missingDates": "Debes seleccionar un rango de fechas",
      "invalidDateRange": "La fecha \"Desde\" no puede ser posterior a la fecha \"Hasta\"",
      "load": "Error al cargar el panel de costos"
    },
    "loading": "Refrescando…",
    "chartDimension": "Dimensión",
    "chartMetric": "Métrica",
    "chartTitle": "Gráfico de costos",
    "chartType": "Tipo de gráfico",
    "chartTypeArea": "Área",
    "chartTypeBar": "Barras",
    "chartTypeLine": "Líneas",
    "chartTypePie": "Pastel",
    "colActividad": "Actividad",
    "colCategoria": "Categoría",
    "colCosto": "Costo",
    "colFecha": "Fecha",
    "colGeocerca": "Geocerca",
    "colHoras": "Horas",
    "colMoneda": "Moneda",
    "colPersona": "Persona",
    "colRegistros": "Registros",
    "colTarifaPromedio": "Tarifa promedio",
    "dimensionActividad": "Actividad",
    "dimensionFecha": "Fecha",
    "dimensionGeocerca": "Geocerca",
    "dimensionPersona": "Persona",
    "filtersActivity": "Actividad",
    "filtersAll": "Todos",
    "filtersApply": "Aplicar filtros",
    "filtersClear": "Limpiar filtros",
    "filtersFrom": "Desde",
    "filtersGeofence": "Geocerca",
    "filtersPerson": "Persona",
    "filtersTitle": "Filtros",
    "filtersTo": "Hasta",
    "kpiCurrencies": "Monedas",
    "metricCost": "Costo",
    "metricHours": "Horas",
    "metricRecords": "Registros",
    "metricAvgRate": "Tarifa promedio",
    "tableEmpty": "No hay datos para mostrar",
    "tableNoResults": "No hay datos para los filtros actuales",
    "tableTitle": "Detalle para la dimensión seleccionada",
    "chartNoData": "Sin datos disponibles",
    "loadingAuth": "Cargando tu sesión y organización actual…",
    "noOrgAssigned": "No hay organización activa para este usuario.",
    "noAccess": "No tienes acceso a este módulo",
    "currentRole": "Rol actual",
    "noRole": "sin rol",
    "loadingPermissions": "Cargando permisos…",
    "currenciesSummaryTitle": "Resumen por moneda",
    "labelHours": "horas",
    "exportNoData": "No hay datos para exportar",
    "exportChartError": "No se pudo exportar el gráfico"
  },
  "forgot": {
    "back": "Volver a iniciar sesión",
    "email": "Correo",
    "emailPh": "tu@correo.com",
    "errorEmail": "Ingresa un correo válido.",
    "errorGeneric": "No se pudo enviar el correo.",
    "noteDesc": "El enlace entrará por /auth/callback y te enviará a /reset-contraseña para crear la nueva contraseña.",
    "noteTitle": "Nota",
    "send": "Enviar enlace",
    "sending": "Enviando…",
    "subtitle": "Te enviaremos un enlace para crear una nueva contraseña. Si no te llega, revisa SPAM.",
    "success": "✅ Si el correo existe, te llegará un enlace para crear una nueva contraseña. Revisa SPAM y ábrelo en el mismo navegador.",
    "tip": "Tip: si el enlace falla, genera uno nuevo y ábrelo en una ventana de incógnito.",
    "title": "Restablecer contraseña"
  },
  "geocercas": {
    "areaUnitLabel": "Unidad de área",
    "areaLabel": "Área",
    "buttonClearCanvas": "Limpiar mapa",
    "buttonDeleteSelected": "Eliminar seleccionadas",
    "buttonDrawByCoords": "Dibujar por coordenadas",
    "buttonSave": "Guardar geocerca",
    "buttonShowAll": "Mostrar todas",
    "buttonShowOnMap": "Mostrar en mapa",
    "buttonShowSelected": "Mostrar seleccionadas",
    "cardListBody": "Próximamente podrás ver aquí el listado de geocercas existentes y sus detalles. Por ahora, usa la opción de Nueva geocerca para crear y editar.",
    "cardListTitle": "Listado de geocercas",
    "cardNewBody": "Crea una nueva geocerca en el mapa, mide su superficie y asígnala a tu personal o actividades.",
    "cardNewCta": "Ir a Nueva geocerca →",
    "cardNewTitle": "Nueva geocerca",
    "currentOrgLabel": "Organización actual:",
    "currentUserLabel": "Usuario:",
    "cursorHint": "Mueve el mouse sobre el mapa",
    "deleteConfirm": "¿Eliminar las geocercas seleccionadas?",
    "deletedCount": "Eliminadas: {{count}}",
    "draftLabel": "Borrador",
    "errorCoordsInvalid": "Coordenadas inválidas. Usa formato: lat,lng (una por línea).",
    "errorNameRequired": "Escribe un nombre para la geocerca.",
    "errorNoGeojson": "No se encontró el GeoJSON de la geocerca.",
    "errorNoShape": "Dibuja una geocerca o crea una por coordenadas antes de guardar.",
    "errorSelectAtLeastOne": "Selecciona al menos una geocerca.",
    "lat": "Lat",
    "lng": "Lng",
    "loadingDataset": "Cargando dataset...",
    "loadingGeofence": "Cargando geocerca…",
    "modalDraw": "Draw",
    "modalHintRule": "1 point = small square | 2 points = rectangle | 3+ = polygon",
    "modalInstruction": "Format:",
    "modalOnePerLine": "(one per line)",
    "modalTitle": "Draw by coordinates",
    "noGeofences": "Aún no tienes geocercas creadas.",
    "noOrgFallback": "— (sin organización seleccionada)",
    "pageSubtitle": "Administra las geocercas de tu organización. Puedes crear zonas en el mapa, medir su área y revisar las existentes.",
    "pageTitle": "Geocercas",
    "panelTitle": "Geocercas",
    "placeholderName": "Nombre de la geocerca",
    "pointsLabel": "Pts",
    "savedOk": "Geocerca guardada correctamente.",
    "subtitleNew": "Dibuja una geocerca en el mapa y asígnala a tu personal o actividades.",
    "titleNew": "Nueva geocerca",
    "coordsReady": "Figura creada desde coordenadas.",
    "errorSave": "No se pudo guardar la geocerca. Intenta nuevamente.",
    "deleteError": "No se pudo eliminar. Intenta nuevamente.",
    "errorLoad": "No se pudo cargar la geocerca.",
    "showManyOk": "Mostrando {{count}} geocercas.",
    "planUsageTitle": "Geocercas",
    "planAvailableTitle": "Disponibles",
    "draftYes": "sí",
    "draftNo": "no",
    "create": {
      "defaultName": "Casa",
      "nameLabel": "Nombre",
      "coordsLabel": "Coordenadas",
      "coordsHint": "(lat, lng) por línea",
      "missingGeometry": "Agrega coordenadas (texto \"lat, lng\" por línea) o dibuja un polígono en el mapa.",
      "polygonFallback": "Si el cuadro queda vacío, se usará el polígono dibujado en el mapa."
    },
    "errors": {
      "noEditPermission": "No tienes permisos para editar.",
      "selectOrganizationFirst": "Selecciona una organización primero."
    },
    "plan": {
      "loading": "Cargando plan...",
      "error": "No se pudieron cargar los límites del plan.",
      "unlimited": "Geocercas sin límite configurado.",
      "usage": "Uso actual: {{used}} / {{max}} geocercas",
      "unlimitedShort": "Ilimitadas",
      "limitReached": "Has alcanzado el límite de geocercas de tu plan actual. Actualiza a PRO para continuar.",
      "limitReachedTitle": "Has alcanzado el límite de geocercas de tu plan.",
      "limitReachedBody": "Para crear más geocercas, actualiza tu organización a PRO.",
      "freeHint": "Plan FREE activo. Cuando alcances el límite, podrás hacer mejora de plan a PRO desde aquí.",
      "activePaidHint": "Tu organización tiene un plan con mayor capacidad habilitada."
    }
  },
  "help": {
    "common": {
      "back": "Volver",
      "badge": "Centro de ayuda",
      "breadcrumb": "Centro de Ayuda",
      "goHome": "Ir a Inicio",
      "quickGuideBadge": "Guía rápida",
      "viewFaq": "Ver FAQ"
    },
    "faq": {
      "breadcrumb": "Centro de Ayuda / Preguntas frecuentes",
      "title": "Preguntas frecuentes",
      "subtitle": "Respuestas rápidas a las dudas más comunes.",
      "goHome": "Ir a Inicio",
      "items": [
        {
          "q": "¿Cómo invito a un tracker?",
          "a": "Ve a Invitar tracker, escribe el correo y envía la invitación."
        },
        {
          "q": "¿Cómo activo un tracker con código de emparejamiento?",
          "a": "El administrador selecciona a la persona en Invitar tracker, genera un código y lo copia. El tracker debe iniciar sesión con Magic Link, abrir /tracker-accept, pegar el código y presionar Activar tracking con código. El código no reemplaza la identidad: solo vincula la organización, la persona y el tracker autenticado."
        },
        {
          "q": "¿Puedo medir áreas con la app?",
          "a": "Sí. Al crear o editar una geocerca, la app calcula el área del polígono y permite verla en unidades como m², hectáreas o acres, según la unidad configurada."
        },
        {
          "q": "¿Qué pasa si el enlace venció?",
          "a": "Solicita una nueva invitación desde la organización."
        }
      ],
      "backToPanel": "Ir al panel",
      "sections": [
        {
          "items": [
            {
              "a": "Necesitas una invitación de un Propietario/Admin de una organización. Si no tienes acceso, solicita que te inviten.",
              "q": "¿Cómo obtengo acceso a la app?"
            },
            {
              "a": "Propietario gestiona la organización y administradores. Administrador gestiona datos operativos (geocercas, personal, actividades, asignaciones). Tracker es un usuario de campo que envía puntos GPS.",
              "q": "¿Cuál es la diferencia entre Propietario, Administrador y Tracker?"
            },
            {
              "a": "Sí. Los Propietarios pueden trabajar con varias organizaciones y cambiar usando el selector de organización.",
              "q": "¿Puedo manejar más de una organización?"
            }
          ],
          "title": "Acceso y roles"
        },
        {
          "items": [
            {
              "a": "El tracker puede estar sin conexión, sin permisos de ubicación, o sin asignación activa. Verifica permisos y asignaciones.",
              "q": "¿Por qué veo “Sin datos recientes” en Tracker?"
            },
            {
              "a": "La frecuencia se define en la asignación. El mínimo permitido es 5 minutos para cuidar batería y datos.",
              "q": "¿Cada cuánto se envía la ubicación?"
            },
            {
              "a": "Sí. El tracker puede almacenar puntos y sincronizar cuando regresa la conectividad (según tu build y permisos).",
              "q": "¿Funciona con señal débil?"
            }
          ],
          "title": "seguimiento"
        },
        {
          "items": [
            {
              "a": "Los costos se calculan a partir de las asignaciones (horas) y la tarifa por hora configurada en cada actividad.",
              "q": "¿Cómo se calculan los costos?"
            },
            {
              "a": "Sí. Los reportes se exportan como CSV, que puedes abrir en Excel o Google Sheets.",
              "q": "¿Puedo exportar a Excel?"
            },
            {
              "a": "Sí. Usa los filtros en Reportes y panel Costos para enfocarte por geocerca(s), persona(s), actividad(es) y fechas.",
              "q": "¿Puedo filtrar por geocerca, persona, actividad y rango de fechas?"
            }
          ],
          "title": "Costos y reportes"
        },
        {
          "items": [
            {
              "a": "Solo los puntos necesarios para seguimiento y validación por geocerca. El acceso está controlado por roles y organización.",
              "q": "¿Qué datos de ubicación se guardan?"
            },
            {
              "a": "No. Los datos están aislados por organización (multi-tenant) y protegidos por reglas de seguridad en base de datos.",
              "q": "¿Un tracker puede ver datos de otras organizaciones?"
            }
          ],
          "title": "Datos y privacidad"
        }
      ],
      "seeQuickGuide": "Ver guía rápida"
    },
    "instructions": {
      "badge": "Guía rápida",
      "bestPractice1Body": "Usa siempre el mismo teléfono para evitar cortes en el seguimiento.",
      "bestPractice1Title": "Usa tu teléfono principal",
      "bestPractice2Body": "Mantén batería suficiente o conecta el cargador durante jornadas largas.",
      "bestPractice2Title": "Cuida la batería",
      "bestPractice3Body": "No cierres sesión ni desactives ubicación mientras estés en ruta.",
      "bestPractice3Title": "Mantén la sesión activa",
      "bestPractice4Body": "Si algo no carga, vuelve a abrir el enlace de invitación más reciente.",
      "bestPractice4Title": "Reabre el enlace si falla",
      "goToSteps": "Ir a pasos",
      "recommendationBody": "Antes de salir, revisa que veas el estado \"Seguimiento activo\" en tu pantalla.",
      "recommendationTitle": "Recomendación",
      "resultBullets": [
        "Tu invitación fue aceptada correctamente.",
        "Concediste permisos de ubicación en el teléfono.",
        "Ves el estado \"Seguimiento activo\".",
        "Mantienes internet y ubicación habilitadas.",
        "Si no funciona, puedes pedir una nueva invitación o contactar soporte."
      ],
      "resultIntro": "Al finalizar, deberías tener todo listo para compartir ubicación sin problemas:",
      "resultTitle": "Qué debes confirmar",
      "steps": {
        "title": "Paso a paso",
        "subtitle": "Sigue esta secuencia simple para activar el tracker en pocos minutos.",
        "items": [
          {
            "title": "Recibe tu invitación",
            "items": [
              "Te llegará un enlace por correo o mensaje desde tu organización."
            ]
          },
          {
            "title": "Activa con código si tu administrador te lo dio",
            "items": [
              "Inicia sesión con Magic Link.",
              "Abre /tracker-accept, pega el código y presiona Activar tracking con código."
            ]
          },
          {
            "title": "Abre el enlace en tu teléfono",
            "items": [
              "Ábrelo en el mismo teléfono que usarás para el tracker."
            ]
          },
          {
            "title": "Acepta permisos de ubicación",
            "items": [
              "Cuando se soliciten, permite los permisos de ubicación."
            ]
          },
          {
            "title": "Confirma que aparece \"Seguimiento activo\"",
            "items": [
              "Ese estado indica que tu ubicación se está compartiendo correctamente."
            ]
          },
          {
            "title": "Mantén conexión y ubicación habilitadas",
            "items": [
              "Durante tu jornada, mantén encendidas la conexión y la ubicación."
            ]
          }
        ]
      },
      "subtitle": "Activa tu tracker con pasos simples y mensajes claros, sin configuración técnica.",
      "tipsTitle": "Buenas prácticas",
      "title": "Guía rápida del tracker",
      "toc": {
        "title": "Tabla de contenido",
        "subtitle": "Usa estos accesos para avanzar rápido.",
        "items": [
          "Pasos",
          "Buenas prácticas",
          "Módulos operativos",
          "Resultado esperado",
          "Recomendación"
        ]
      },
      "viewFaq": "Ver FAQ",
      "viewResult": "Ver resultado",
      "moduleCards": {
        "title": "Módulos operativos",
        "subtitle": "Usa estas tarjetas para entrar rápido a los módulos de planificación y análisis de eficiencia.",
        "items": [
          {
            "badge": "PLANIFICACIÓN",
            "title": "Planificación",
            "body": "Organiza tareas por geocerca, persona, actividad y periodo. Permite revisar estado, avance, fechas y costos planificados para coordinar el trabajo operativo.",
            "highlights": [
              "Crear y revisar asignaciones por periodo.",
              "Coordinar actividades antes de ejecutar el trabajo.",
              "Usar datos reales de la organización activa."
            ],
            "cta": "Abrir Planificación",
            "path": "/planificacion"
          },
          {
            "badge": "BENCHMARKING",
            "title": "Benchmarking",
            "body": "Compara eficiencia entre geocercas, personas, actividades o asignaciones usando horas/m², $/m² y métricas auxiliares por ha o km².",
            "highlights": [
              "Identificar mejores y peores eficiencias.",
              "Revisar semáforos y oportunidades de mejora.",
              "Exportar resultados a CSV para análisis externo."
            ],
            "cta": "Abrir Benchmarking",
            "path": "/benchmarking"
          }
        ]
      }
    },
    "reportsGuide": {
      "badge": "Guía de reportes",
      "breadcrumb": "Centro de Ayuda / Reportes",
      "title": "Guía de reportes",
      "subtitle": "Consulta datos, filtra resultados y exporta el análisis que necesitas para decidir con rapidez.",
      "goHome": "Ir a Inicio",
      "goToFilters": "Ir a filtros",
      "openReports": "Abrir reportes",
      "overviewTitle": "¿Qué puedes revisar en Reportes?",
      "overviewBody": "Aquí puedes entender el comportamiento por geocerca, persona, actividad y periodo de tiempo, con un resumen operativo listo para análisis y toma de decisiones.",
      "summaryTitle": "Resultado esperado",
      "summaryBody": "Al terminar, tendrás la vista correcta del rendimiento y podrás exportar los datos para compartirlos.",
      "resultTitle": "Qué debes comprobar",
      "summaryBullets": [
        "El rango de fechas coincide con el periodo que necesitas revisar.",
        "Los filtros por geocerca, persona y actividad están alineados con la operación.",
        "Los KPI muestran la tendencia y los puntos de riesgo o mejora.",
        "Puedes exportar los datos a CSV si necesitas compartir el análisis."
      ],
      "toc": {
        "title": "Tabla de contenido",
        "subtitle": "Usa estos accesos para avanzar rápido.",
        "items": [
          "Resumen",
          "Filtros",
          "Exportación",
          "Interpretación",
          "Buenas prácticas"
        ]
      },
      "cards": [
        {
          "tag": "KPI",
          "title": "Horas totales",
          "body": "Revisa la carga real por periodo y compara la operación entre días, personas o geocercas."
        },
        {
          "tag": "COSTO",
          "title": "Costo total",
          "body": "Analiza el impacto económico del trabajo ejecutado y detecta actividades con mayor gasto."
        },
        {
          "tag": "ASIGNACIÓN",
          "title": "Tendencia por actividad",
          "body": "Mira cómo cambia el rendimiento de cada actividad con el tiempo para priorizar acciones."
        }
      ],
      "sections": {
        "title": "Cómo usar reportes",
        "items": [
          {
            "title": "Define el rango de tiempo",
            "body": "Elige desde y hasta para centrar el análisis en el periodo correcto antes de interpretar los resultados.",
            "bullets": [
              "Usa días, semanas o meses según la decisión que quieras tomar.",
              "Verifica que el rango incluya todo el trabajo operativo relevante."
            ]
          },
          {
            "title": "Aplica filtros por contexto",
            "body": "Restringe la vista por geocerca, persona y actividad para aislar problemas o comparar ejecuciones reales.",
            "bullets": [
              "Combina filtros para revisar un detalle puntual o una vista global.",
              "Limpia los filtros cuando quieras volver a la vista general."
            ]
          },
          {
            "title": "Interpreta los indicadores",
            "body": "Busca cambios en horas, costo y proporciones para identificar diferencias de eficiencia o zonas de mejora.",
            "bullets": [
              "Compara el mismo periodo con tendencias previas.",
              "Revisa los valores más altos y los más bajos antes de actuar."
            ]
          },
          {
            "title": "Exporta cuando necesites compartir",
            "body": "Si el análisis va a ir a un correo, Excel o comité operativo, exporta la tabla con los datos filtrados.",
            "bullets": [
              "Usa CSV para abrirlo en Excel, Google Sheets o herramientas de análisis.",
              "Haz una exportación por segmento cuando la consulta sea muy específica."
            ]
          }
        ]
      },
      "exportTitle": "Exportación y análisis",
      "exportPrimaryTitle": "Descarga para trabajo externo",
      "exportPrimaryBody": "La exportación te permite abrir los resultados en Excel o Google Sheets para compartir con supervisión, finanzas o coordinación.",
      "exportSecondaryTitle": "Usa la vista como diagnóstico",
      "exportSecondaryBody": "La combinación de filtros y KPI te ayuda a validar si la ejecución está dentro del plan o si requiere corregir la operación.",
      "tips": {
        "title": "Buenas prácticas",
        "items": [
          {
            "title": "Mantén un rango claro",
            "body": "Un periodo demasiado amplio puede ocultar cambios puntuales; un rango corto puede ser demasiado fino para decidir."
          },
          {
            "title": "Filtra por caso real",
            "body": "Si quieres comparar dos equipos o dos zonas, limita el análisis a esos segmentos para evitar ruido."
          },
          {
            "title": "Usa la exportación como evidencia",
            "body": "Cuando necesites presentar resultados, exporta el dato limpio y comparte el contexto del período analizado."
          },
          {
            "title": "Revisa la tendencia",
            "body": "No te fijes solo en el valor del día; compara la serie para detectar cambios sostenidos."
          }
        ]
      }
    },
    "support": {
      "breadcrumb": "Centro de Ayuda / Soporte",
      "calendlyLabel": "Calendly",
      "emailLabel": "Correo de soporte",
      "goHome": "Ir a Inicio",
      "whatsappLabel": "WhatsApp",
      "viewFaq": "Ver FAQ",
      "faqLink": "Preguntas frecuentes",
      "notConfigured": "El contacto de soporte aún no está configurado.",
      "subtitle": "Contáctanos para soporte técnico, dudas de facturación o capacitación.",
      "commonProblems": {
        "title": "Problemas comunes",
        "subtitle": "Si algo no funciona, revisa estas soluciones rápidas antes de contactar soporte.",
        "items": [
          {
            "title": "No puedo aceptar la invitación",
            "desc": "Abre el enlace más reciente que te enviaron. Si ya venció o aparece error, pide una nueva invitación."
          },
          {
            "title": "El código de emparejamiento no funciona",
            "desc": "Asegúrate de iniciar sesión primero con Magic Link en el mismo navegador o teléfono. Luego pega el código más reciente en /tracker-accept. Si aparece que el usuario ya está vinculado a otra persona, el administrador debe generar el código para la persona correcta o usar otro correo tracker."
          },
          {
            "title": "El enlace no funciona",
            "desc": "Cópialo completo en tu navegador del teléfono o ábrelo directamente desde el mensaje original."
          }
        ]
      },
      "title": "Soporte"
    },
    "onboarding": {
      "title": "Primeros pasos",
      "subtitle": "Cómo comenzar a usar el tracker por primera vez.",
      "orgCreationLimitReached": "Ya tienes una organización creada. Puedes cambiar de organización o contactar soporte para crear una organización adicional.",
      "orgCreateFailed": "No se pudo crear la organización.",
      "sections": [
        {
          "title": "Invitación y acceso",
          "items": [
            {
              "q": "¿Cómo empiezo a usar el tracker?",
              "a": "Recibirás un enlace de invitación. Solo debes abrirlo desde tu teléfono y seguir los pasos."
            },
            {
              "q": "¿Necesito instalar algo?",
              "a": "No. Solo abre el enlace y acepta los permisos cuando se te soliciten."
            }
          ]
        }
      ]
    },
    "tracker": {
      "title": "Seguimiento de ubicación",
      "subtitle": "Qué significa que el seguimiento esté activo.",
      "sections": [
        {
          "title": "Estado del seguimiento",
          "items": [
            {
              "q": "¿Qué significa 'Seguimiento activo'?",
              "a": "Significa que tu ubicación se está compartiendo correctamente."
            },
            {
              "q": "¿Debo dejar la app abierta?",
              "a": "No siempre. Mientras tu dispositivo tenga permisos y conexión, el seguimiento puede continuar."
            }
          ]
        }
      ]
    },
    "troubleshooting": {
      "title": "Problemas frecuentes",
      "subtitle": "Soluciones rápidas para los casos más comunes.",
      "sections": [
        {
          "title": "Invitación y permisos",
          "items": [
            {
              "q": "No puedo aceptar la invitación",
              "a": "Asegúrate de abrir el enlace más reciente. Si sigue fallando, solicita una nueva invitación."
            },
            {
              "q": "El enlace indica que está inactivo",
              "a": "Eso puede ocurrir si abriste un enlace anterior. Usa el último enlace recibido."
            },
            {
              "q": "No se inicia el seguimiento",
              "a": "Verifica que aceptaste los permisos de ubicación en tu dispositivo."
            }
          ]
        }
      ]
    },
    "geofences": {
      "title": "Geocercas",
      "subtitle": "Qué son y cómo funcionan dentro del seguimiento.",
      "sections": [
        {
          "title": "Conceptos básicos",
          "items": [
            {
              "q": "¿Qué es una geocerca?",
              "a": "Es una zona definida en el mapa para registrar entradas, salidas o presencia."
            },
            {
              "q": "¿Puedo medir áreas con la app?",
              "a": "Sí. Al crear o editar una geocerca, la app calcula el área del polígono y permite verla en unidades como m², hectáreas o acres, según la unidad configurada."
            },
            {
              "q": "¿Tengo que hacer algo como tracker?",
              "a": "No. El sistema registra automáticamente tu actividad cuando corresponde."
            }
          ]
        }
      ]
    },
    "account": {
      "title": "Cuenta y acceso",
      "subtitle": "Preguntas sobre inicio de sesión y acceso a la organización.",
      "sections": [
        {
          "title": "Acceso",
          "items": [
            {
              "q": "¿Cómo inicio sesión?",
              "a": "Usa tu correo y contraseña desde la pantalla de inicio."
            },
            {
              "q": "¿Qué hago si estoy en la organización incorrecta?",
              "a": "Asegúrate de usar el enlace de invitación correcto o vuelve a ingresar con la cuenta indicada."
            }
          ]
        }
      ]
    },
    "changelog": {
      "breadcrumb": "Centro de Ayuda / Historial de cambios",
      "back": "Volver",
      "title": "Historial de cambios",
      "subtitle": "Mejoras y actualizaciones recientes de la aplicación.",
      "goHome": "Ir a Inicio",
      "releases": [
        {
          "version": "v1.2.0 · 2026-04",
          "items": [
            "Mejora en el flujo de invitación de trackers",
            "Seguimiento más estable y confiable",
            "Nueva interfaz más clara y consistente",
            "Corrección de errores en activación de seguimiento"
          ]
        },
        {
          "version": "v1.1.0 · 2026-03",
          "items": [
            "Sistema de geocercas mejorado",
            "Optimización de rendimiento",
            "Mejoras en inicio de sesión y manejo de sesión"
          ]
        }
      ],
      "items": [
        {
          "version": "v1.2.0",
          "date": "2026-04",
          "changes": [
            "Mejora en el flujo de invitación de trackers",
            "Seguimiento más estable y confiable",
            "Nueva interfaz más clara y consistente",
            "Corrección de errores en activación de seguimiento"
          ]
        },
        {
          "version": "v1.1.0",
          "date": "2026-03",
          "changes": [
            "Sistema de geocercas mejorado",
            "Optimización de rendimiento",
            "Mejoras en inicio de sesión y manejo de sesión"
          ]
        }
      ]
    }
  },
  "home": {
    "loadingPermissions": "Cargando permisos...",
    "startBadge": "Inicio",
    "loginToContinue": "Inicia sesión para continuar.",
    "goToLogin": "Ir a iniciar sesión",
    "quickStart": "Guía rápida",
    "accountStatusBadge": "Estado de cuenta",
    "missingContextTitle": "Cuenta creada correctamente",
    "missingContextBody": "Tu cuenta ya existe, pero todavía no está vinculada a una organización.",
    "trackerWaitingTitle": "Si eres tracker",
    "trackerWaitingStep1": "Avisa al administrador que ya creaste tu cuenta.",
    "trackerWaitingStep2": "Espera el enlace de invitación.",
    "trackerWaitingStep3": "Abre el enlace desde este mismo teléfono.",
    "trackerWaitingStep4": "Después podrás usar el tracking GPS.",
    "installTrackerAppCta": "Instalar app para tracking GPS",
    "pendingInvitation": "Pendiente de invitación",
    "pending": "Pendiente",
    "retry": "Revisar nuevamente",
    "previewEnvironment": "Estás revisando un deployment Preview.",
    "quickActions": "Acciones rápidas",
    "manageWorkspace": "Gestiona tu espacio de trabajo",
    "manageWorkspaceDesc": "Accede al panel principal, revisa tu plan o administra la cuenta desde un solo lugar.",
    "subscriptionSummary": "Resumen del plan",
    "helpCenterTitle": "Ayuda y aprendizaje",
    "helpCenterDesc": "Encuentra guías rápidas, preguntas frecuentes, soporte y novedades del sistema.",
    "quickGuideCards": "Centro de Ayuda",
    "goDashboard": "Ir al panel",
    "deleteAccount": "Eliminar cuenta",
    "help": {
      "title": "Centro de ayuda",
      "quick": "Guía rápida",
      "quickDesc": "Aprende cómo usar la app paso a paso.",
      "faq": "Preguntas frecuentes",
      "faqDesc": "Respuestas a las dudas más comunes.",
      "support": "Soporte",
      "supportDesc": "¿Tienes un problema o consulta? Contáctanos.",
      "news": "Novedades",
      "newsDesc": "Cambios, mejoras y actualizaciones recientes."
    }
  },
  "deleteAccount": {
    "title": "Eliminar cuenta",
    "subtitle": "Solicita la eliminación permanente de tu cuenta de GeoField GPS y de los datos asociados.",
    "warning": {
      "title": "Advertencia",
      "body": "Eliminar tu cuenta es permanente y no se puede deshacer."
    },
    "whatWillBeDeleted": {
      "title": "Qué se eliminará",
      "items": {
        "accountInfo": "Información de la cuenta de usuario",
        "profileData": "Datos del perfil personal",
        "trackerAssignments": "Asignaciones de trackers",
        "gpsRecords": "Registros de ubicación GPS",
        "geofences": "Geocercas creadas por la cuenta",
        "activityLogs": "Registros de actividad relacionados con la cuenta"
      }
    },
    "retention": {
      "title": "Nota de retención",
      "body": "Algunos datos limitados pueden conservarse temporalmente cuando sea necesario por cumplimiento legal, prevención de fraude o motivos de seguridad."
    },
    "processingTime": {
      "title": "Tiempo de procesamiento",
      "body": "Las solicitudes de eliminación de cuenta se procesan dentro de los 30 días posteriores a la recepción de la solicitud. Una vez completado el proceso, la cuenta y los datos asociados no podrán recuperarse."
    },
    "account": {
      "title": "Cuenta",
      "signedInAs": "Sesión iniciada como:",
      "unknownUser": "Usuario desconocido"
    },
    "confirmCheckbox": "Entiendo que esta acción es permanente y que los datos de mi cuenta no podrán recuperarse.",
    "confirmInputLabel": "Escribe DELETE para confirmar",
    "confirmKeyword": "DELETE",
    "submitButton": "Solicitar eliminación de cuenta",
    "submitting": "Enviando...",
    "successMessage": "Tu solicitud de eliminación fue recibida. Tu cuenta y los datos asociados se eliminarán dentro de los próximos 30 días.",
    "publicPolicyLink": "Ver política pública de eliminación",
    "errors": {
      "noAuthenticatedUser": "No se encontró un usuario autenticado activo.",
      "confirmationRequired": "Confirma la acción y escribe \"DELETE\" para continuar.",
      "requestFailed": "No se pudo crear la solicitud de eliminación."
    }
  },
  "inicio": {
    "cards": {
      "common": {
        "soon": "Próximamente"
      },
      "faq": {
        "badge": "Ayuda",
        "body": "Encuentra respuestas a las dudas más comunes sobre invitaciones, roles, costos y uso del tracker.",
        "cta": "Ver preguntas frecuentes",
        "title": "Preguntas frecuentes"
      },
      "instrucciones": {
        "badge": "Guía rápida",
        "body": "Sigue paso a paso cómo configurar organizaciones, geocercas, personal, actividades y trackers.",
        "cta": "Ver instrucciones",
        "title": "Instrucciones"
      },
      "novedades": {
        "badge": "Novedades",
        "body": "Revisa el historial de cambios, nuevas funciones, mejoras y correcciones de la plataforma.",
        "cta": "Ver changelog",
        "title": "Novedades / Changelog"
      },
      "queEs": {
        "badge": "Información",
        "body": "Conoce la visión, los casos de uso y los beneficios de GeoField GPS para tu organización.",
        "cta": "Leer más",
        "title": "¿Qué es GeoField GPS?"
      },
      "soporte": {
        "badge": "Soporte",
        "body": "¿Necesitas ayuda? Contáctanos para soporte técnico, facturación o dudas sobre tu cuenta.",
        "cta": "Ir a soporte",
        "title": "Contacto / Soporte"
      },
      "videoDemo": {
        "badge": "Video",
        "body": "Mira una demostración corta de cómo funciona GeoField GPS en la vida real.",
        "cta": "Ver video demo",
        "title": "Video demo"
      }
    },
    "header": {
      "badge": "Centro de ayuda y recursos",
      "subtitle": "Desde aquí puedes acceder a instrucciones, preguntas frecuentes, soporte y novedades de GeoField GPS.",
      "title": "Bienvenido a tu panel"
    },
    "onboarding": {
      "badge": "Configuración inicial",
      "title": "Empieza en 5 pasos",
      "stepGeocercas": "1. Geocercas",
      "stepPersonal": "2. Personal",
      "stepActividades": "3. Actividades",
      "stepAsignaciones": "4. Asignaciones",
      "stepInvitarTracker": "5. Invitar tracker"
    },
    "userInfo": {
      "connectedAs": "Conectado como",
      "inOrg": "en la organización",
      "orgIdLabel": "ID de organización:",
      "userLabel": "Usuario:",
      "withRole": "con el rol"
    },
    "billing": {
      "managePlan": "Administrar plan",
      "managePlanBody": "Puedes entrar a la página Billing para ver y manejar tu suscripción.",
      "goToBilling": "Ir a Billing",
      "previewNote": ""
    }
  },
  "inviteTracker": {
    "backToTracker": "Volver a Tracker",
    "emailLabel": "Correo electrónico del tracker",
    "emailPlaceholder": "tracker@ejemplo.com",
    "errors": {
      "emailInvalid": "Ingresa un correo electrónico válido.",
      "emailRequired": "Debes ingresar un correo electrónico.",
      "noOrg": "No se pudo resolver una organización activa para este usuario.",
      "planBlocked": "El plan actual de la organización no permite invitaciones de tracker.",
      "planLoadFailed": "No se pudo cargar la información del plan para esta organización.",
      "trackerCountFailed": "No se pudo consultar el cupo de trackers disponible.",
      "notInOrg": "Tu usuario no está vinculado a la organización activa.",
      "inviteErrorPrefix": "Error al enviar la invitación"
    },
    "form": {
      "buttonSend": "Enviar invitación",
      "buttonSending": "Enviando invitación…",
      "emailHelp": "Se enviará una invitación a este correo.",
      "emailLabel": "Correo electrónico del tracker",
      "emailPlaceholder": "tracker@ejemplo.com",
      "selectHelp": "Si seleccionas un personal, su correo se llenará automáticamente.",
      "selectLabel": "Selecciona personal vigente (opcional)",
      "selectPlaceholder": "-- Seleccionar personal --"
    },
    "diag": {
      "orgUsed": "Organización usada",
      "user": "Usuario",
      "membersLoaded": "Miembros cargados"
    },
    "empty": {
      "noMembers": "No hay personal activo disponible para invitar."
    },
    "ok": {
      "generated": "Invitación generada correctamente.",
      "emailSent": "Correo de invitación enviado correctamente.",
      "fallbackLink": "No se pudo enviar el correo. Usa este enlace para compartir el acceso manualmente.",
      "magicLinkFallback": "Link mágico generado como respaldo."
    },
    "plan": {
      "validating": "Validando plan de la organización…",
      "validationError": "No se pudo validar el plan de la organización.",
      "permissionDisabledTitle": "Permiso de invitación no habilitado",
      "permissionDisabledBody": "Esta organización no puede invitar trackers en este momento.",
      "detectedPlan": "Plan detectado"
    },
    "messages": {
      "createdWithoutEmail": "Se creó el acceso del tracker sin enviar correo electrónico.",
      "genericProcessed": "La invitación para {{correo}} se procesó correctamente.",
      "invited": "Se ha enviado una invitación a {{correo}} para unirse como tracker en {{orgName}}.",
      "linkOnlyNoLink": "La invitación fue creada, pero no se recibió un enlace público.",
      "linkOnlyWithLink": "La invitación fue creada. Usa este enlace para compartir el acceso: {{link}}.",
      "magiclinkSent": "Se envió un link mágico de acceso a {{correo}}.",
      "notOk": "No se pudo completar la invitación. Revisa el correo e inténtalo de nuevo.",
      "serverProblem": "Hubo un problema al contactar al servidor de invitaciones.",
      "unexpectedError": "Error inesperado al procesar la invitación."
    },
    "onlyExistingNote": "Solo se puede invitar a personas existentes en tu organización.",
    "orgFallback": "tu organización",
    "selectPersonLabel": "Selecciona una persona",
    "sendInvite": "Enviar invitación",
    "subtitle": "Selecciona un miembro de tu personal o ingresa un correo manualmente para invitarlo como tracker en {{orgName}}.",
    "title": "Invitar tracker"
  },
  "landing": {
    "accessBody": "Esta aplicación requiere una cuenta invitada por un administrador. Si no tienes acceso, solicita una invitación a tu organización.",
    "accessHint": "Consejo: usa \"Link mágico\" si tu administrador te invitó con correo.",
    "accessTitle": "Acceso con cuenta autorizada",
    "assistanceControlBody": "Verifica quién estuvo dentro de cada geocerca, en qué horario y en qué actividad.",
    "assistanceControlTitle": "Control de asistencia",
    "brandName": "GeoField GPS",
    "brandTagline": "Control de personal por geocercas",
    "bulletCostsBody": "Consulta paneles tipo Power BI con los costos por persona, actividad y geocerca.",
    "bulletCostsTitle": "Costos",
    "bulletGeocercasBody": "Crea geocercas para campos, fincas, plantas o puntos de servicio y mide superficies en m², hectáreas o acres.",
    "bulletGeocercasTitle": "Geocercas",
    "bulletPersonalBody": "Registra a tu personal y asígnalo a actividades y zonas específicas.",
    "bulletPersonalTitle": "Personal",
    "ctaLogin": "Ir al panel de control",
    "ctaMagic": "Entrar con link mágico",
    "ctaPricing": "Ver precios",
    "ctaStart": "Crear cuenta gratis",
    "email": "Correo",
    "footerFaq": "Preguntas frecuentes",
    "footerPrivacy": "Privacidad",
    "footerSupport": "Soporte",
    "footerTerms": "Términos",
    "goPanel": "Ir al panel",
    "goToDashboard": "Ir al panel",
    "heroBadge": "Control inteligente de campo",
    "heroSubtitle": "Verifica qué lugares visitaron, cuánto tiempo permanecieron y qué actividades realizaron, desde un solo panel.",
    "heroTitle": "Comprueba dónde trabaja tu equipo de campo",
    "heroTitleHighlight": "con geocercas inteligentes",
    "heroTitlePrefix": "Controla a tu personal",
    "heroTitleSuffix": "en cualquier parte del mundo",
    "invalidEmail": "Correo no válido.",
    "livePanelLabel": "Panel en vivo",
    "livePanelTitle": "Operaciones en tiempo real",
    "demoLiveLabel": "Demo en vivo",
    "demoOperationsAreaLabel": "Area de operaciones",
    "demoLoop10sLabel": "Loop 10s",
    "loginTitle": "Iniciar sesión",
    "magicLoginCta": "Entrar con link mágico",
    "noAccount": "¿No tienes cuenta?",
    "createAccount": "Crear cuenta",
    "hasPassword": "¿Ya tienes contraseña?",
    "passwordLogin": "Entrar con contraseña",
    "login": "Iniciar sesión",
    "loginButton": "Entrar",
    "logout": "Salir",
    "magicEnter": "Iniciar sesión con enlace mágico",
    "magicLinkError": "No se pudo enviar el enlace. Inténtalo de nuevo.",
    "magicLinkSent": "Te enviamos un enlace de acceso. Revisa tu correo.",
    "magicNote": "Importante: el acceso funciona solo con el enlace mágico real.",
    "multiOrgBody": "Administra varias empresas o proyectos desde una sola cuenta, con roles y permisos separados.",
    "multiOrgTitle": "Multi organización",
    "privacyMiniNote": "Privacidad: la ubicación se usa solo para funciones de geocerca y seguimiento según permisos otorgados por el usuario.",
    "quickAccessDesc": "Si lo prefieres, puedes iniciar sesión usando un enlace mágico (sin contraseña).",
    "quickAccessTitle": "Quick access",
    "reviewNote": "Nota: Si estás revisando la app (Google Play), utiliza las credenciales provistas en Play Console (App access).",
    "rightsReserved": "Todos los derechos reservados",
    "sending": "Sending...",
    "sendMagic": "Send magic link",
    "statusOnline": "Sistema en línea",
    "support": "Support",
    "zonesActive": "Zonas activas",
    "feature1Title": "Supervisión de personal",
    "feature1Body": "Visualiza quién está en ruta, quién llegó y quién salió de un área operativa.",
    "feature2Title": "Control por zonas",
    "feature2Body": "Define geocercas para sedes, rutas, clientes o áreas sensibles, mide su superficie y obtiene contexto visual inmediato.",
    "feature3Title": "Eventos de entrada y salida",
    "feature3Body": "Convierte posiciones GPS en eventos fáciles de revisar para operación, auditoría y seguimiento.",
    "feature4Title": "Listo para equipos en campo",
    "feature4Body": "Úsalo en operaciones comerciales, técnicas, logísticas o de supervisión territorial.",
    "useCase1Title": "Seguridad privada",
    "useCase1Body": "Controla rondas de guardias, entradas a zonas restringidas y supervisión de turnos.",
    "useCase2Title": "Equipos comerciales",
    "useCase2Body": "Verifica visitas a clientes, cobertura territorial y actividad de vendedores.",
    "useCase3Title": "Operaciones técnicas",
    "useCase3Body": "Supervisa técnicos en campo y valida entradas y salidas en zonas de trabajo.",
    "useCase4Title": "Logística urbana",
    "useCase4Body": "Monitorea movimientos dentro de zonas operativas y detecta eventos automáticamente."
  },
  "login": {
    "advancedOptions": "Opciones avanzadas",
    "back": "Back",
    "badge": "(inicio de sesión-V31 NO-JS)",
    "debug": {
      "lang": "LANG DEBUG",
      "i18n": "I18N DEBUG",
      "supabase": "Supabase"
    },
    "email": "Correo",
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "tucorreo@ejemplo.com",
    "errorInvalidCredentials": "Credenciales inválidas.",
    "errorMagicLink": "No se pudo enviar el link mágico.",
    "errorMagicLinkUnexpected": "Error inesperado al enviar el link mágico.",
    "errorMissingCredentials": "Faltan usuario o contraseña.",
    "errorMissingEmail": "Debes ingresar un correo.",
    "errorResetPassword": "No se pudo enviar el correo de recuperación.",
    "errorResetPasswordUnexpected": "Error inesperado al enviar el correo de recuperación.",
    "errors": {
      "bootstrapFailed": "Bootstrap falló (HTTP {{status}}). {{details}}",
      "invalidEmail": "Ingresa un correo electrónico válido.",
      "unknown": "Ocurrió un error al iniciar sesión."
    },
    "errorUnexpected": "Error inesperado al iniciar sesión.",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "forgotPasswordAlt": "¿Prefieres restablecer tu contraseña? (enviar correo)",
    "goToDashboard": "Ir al panel",
    "goToNext": "Ir a",
    "hidePassword": "Ocultar contraseña",
    "info": "Stable WebView/TWA inicio de sesión: native submit (no JS events), anti rate-limit by design.",
    "infoMagicLinkSent": "Hemos enviado un link mágico a tu correo.",
    "infoResetPasswordSent": "Te enviamos un correo para restablecer tu contraseña. Revisa la bandeja de entrada.",
    "hints": {
      "useResetPassword": " — Si nunca creaste contraseña en este entorno, usa \"{{resetTitle}}\" para crearla y luego entra con contraseña."
    },
    "loadingSession": "Cargando tu sesión…",
    "magicButton": "Enviar link mágico",
    "magicDescription": "Te enviaremos un enlace seguro a tu correo para que ingreses sin contraseña.",
    "magicLinkButton": "Enviar link mágico",
    "magicLinkDescription": "Te enviaremos un enlace seguro a tu correo para entrar sin contraseña.",
    "magicLinkSent": "Hemos enviado un link mágico a tu correo.",
    "magicLinkTitle": "Entrar con link mágico",
    "magicSubmitting": "Enviando enlace…",
    "modeDesc": "Si el inicio de sesión es correcto, el servidor redirige a /auth/callback con tokens.",
    "modeMagic": "Link mágico",
    "modePassword": "Contraseña",
    "modeReset": "Restablecer",
    "modeTitle": "Mode: NO-JS (native form submit)",
    "nextHint": "Útil para pruebas en PREVIEW. En producción normalmente no lo cambias.",
    "nextSuffix": "(next)",
    "password": "Contraseña",
    "passwordLabel": "Contraseña",
    "passwordLoginButton": "Entrar con contraseña",
    "passwordPlaceholder": "Ingresa tu contraseña",
    "passwordTip": "Tip: en Preview y Producción la contraseña es distinta (Supabase distinto).",
    "previewBadge": "PREVIEW",
    "sessionActive": "Ya tienes una sesión activa.",
    "sessionStarted": "✅ Sesión iniciada. Entrando…",
    "showPassword": "Mostrar contraseña",
    "submit": "Entrar",
    "submitting": "Ingresando…",
    "subtitle": "Accede a tu cuenta de GeoField GPS",
    "title": "Iniciar sesión",
    "userNotAuthorized": "Este correo no está autorizado. Solicita una invitación al administrador."
  },
  "orgs": {
    "title": "Organizaciones",
    "myTitle": "Mis Organizaciones",
    "createNew": "Crear nueva organización",
    "newTitle": "Nueva organización",
    "form": {
      "name": "Nombre",
      "slugOptional": "Slug (opcional)",
      "namePlaceholder": "Ej. Finca Principal",
      "slugPlaceholder": "ej. mi-finca-principal",
      "create": "Crear"
    }
  },
  "planning": {
    "header": {
      "badge": "Control gerencial operativo",
      "title": "Planificación Operativa",
      "subtitle": "Planifica trabajos por geocerca, compara ejecución real contra presupuesto operativo y detecta desviaciones con semáforos, filtros y exportación gerencial."
    },
    "badges": {
      "localDemo": "Datos demo locales",
      "organizationData": "Datos de la organización seleccionada"
    },
    "periods": {
      "week": "Semana",
      "month": "Mes",
      "quarter": "Trimestre",
      "semester": "Semestre",
      "year": "Año",
      "custom": "Rango personalizado"
    },
    "periodSelector": {
      "title": "Período de análisis",
      "from": "Desde",
      "to": "Hasta"
    },
    "filters": {
      "title": "Filtros gerenciales Plan vs Real",
      "subtitle": "Enfoca la revisión por desviaciones, geocerca, actividad, estado o período. La vista filtrada alimenta KPIs, tabla, Gantt y CSV.",
      "trafficLight": "Semáforo",
      "geofence": "Geocerca",
      "activity": "Actividad",
      "status": "Estado",
      "dateFrom": "Fecha desde",
      "dateTo": "Fecha hasta",
      "all": "Todos",
      "allFeminine": "Todas",
      "showing": "Mostrando {{filtered}} de {{total}} planificaciones de la vista actual. Los KPIs, la tabla, el Gantt y la exportación usan este mismo filtro."
    },
    "actions": {
      "exportCsv": "Exportar CSV ejecutivo",
      "exportEmptyHint": "La exportación se habilita cuando hay planificaciones en la vista filtrada.",
      "clearFilters": "Limpiar filtros",
      "cancel": "Cancelar",
      "saving": "Guardando...",
      "saveEdit": "Guardar edición",
      "savePlanning": "Guardar planificación",
      "viewActive": "Ver activas",
      "viewArchived": "Ver archivadas",
      "edit": "Editar",
      "archive": "Archivar",
      "archiving": "Archivando...",
      "restore": "Restaurar",
      "restoring": "Restaurando..."
    },
    "kpis": {
      "visible": "Planificaciones visibles",
      "closed": "Cerradas",
      "inProgress": "En ejecución",
      "operationalProgress": "Avance operativo",
      "plannedHours": "Horas planificadas",
      "realHours": "Horas reales",
      "hoursDifference": "Dif. horas",
      "hoursCompliance": "% cumplimiento horas",
      "plannedCost": "Costo planificado",
      "realCost": "Costo real",
      "costDifference": "Dif. costo",
      "currentView": "Vista actual"
    },
    "summary": {
      "title": "Resumen ejecutivo por semáforo",
      "subtitle": "Lectura rápida del riesgo operativo según la peor desviación entre horas y costo.",
      "percentOfTotal": "{{percent}}% de {{total}} planificaciones"
    },
    "traffic": {
      "green": "En rango",
      "yellow": "Desviación moderada",
      "red": "Desviación alta",
      "none": "Sin base"
    },
    "trafficDescriptions": {
      "green": "Desviación hasta 10%.",
      "yellow": "Desviación mayor a 10% y hasta 25%.",
      "red": "Desviación mayor a 25%.",
      "none": "No hay base planificada suficiente."
    },
    "form": {
      "newTitle": "Nueva planificación operativa",
      "editTitle": "Editar planificación operativa",
      "newSubtitle": "Registra una planificación operativa para comparar luego contra la ejecución real.",
      "editSubtitle": "Actualiza la planificación de la organización seleccionada sin duplicar registros.",
      "selectGeofence": "Seleccionar geocerca",
      "selectActivity": "Seleccionar actividad",
      "startDate": "Fecha inicio",
      "endDate": "Fecha fin",
      "plannedHours": "Horas planificadas",
      "plannedCost": "Costo planificado",
      "status": "Estado",
      "notes": "Notas",
      "notesPlaceholder": "Notas operativas",
      "autoCostHint": "Se calcula automáticamente según tarifa de actividad y horas{{currency}}.",
      "manualCostHint": "Sin tarifa por hora{{currency}}. Ingresa el costo manualmente.",
      "editSaveHint": "Al guardar, se actualiza esta planificación en la organización seleccionada.",
      "newSaveHint": "Al guardar, se crea la planificación en la organización seleccionada y se actualiza la lista."
    },
    "status": {
      "draft": "Pendiente",
      "approved": "En progreso",
      "closed": "Completada",
      "archived": "Archivada"
    },
    "table": {
      "activeTitle": "Planificaciones activas",
      "archivedTitle": "Planificaciones archivadas",
      "activeSubtitle": "Vista activa con presupuesto, ejecución real, desviaciones, semáforo y totales.",
      "archivedSubtitle": "Historial operativo archivado. Útil para auditoría y revisión posterior.",
      "totalFilteredView": "Total vista filtrada",
      "filteredView": "Vista filtrada",
      "columns": {
        "id": "ID",
        "geofence": "Geocerca",
        "activity": "Actividad",
        "startDate": "Fecha inicio",
        "endDate": "Fecha fin",
        "plannedHours": "Horas planificadas",
        "plannedCost": "Costo planificado",
        "realHours": "Horas reales",
        "realCost": "Costo real",
        "hoursDiff": "Dif. horas",
        "costDiff": "Dif. costo",
        "trafficLight": "Semáforo",
        "status": "Estado",
        "actions": "Acciones"
      }
    },
    "empty": {
      "noFilterResults": "No hay planificaciones que coincidan con los filtros seleccionados.",
      "noArchived": "No hay planificaciones archivadas para esta organización.",
      "noActive": "No hay planificación registrada para esta organización."
    },
    "gantt": {
      "task": "Tarea",
      "titles": {
        "week": "Gantt operativo semanal",
        "month": "Gantt operativo mensual",
        "quarter": "Gantt operativo trimestral",
        "semester": "Gantt operativo semestral",
        "year": "Gantt operativo anual",
        "customDay": "Gantt operativo personalizado por día",
        "customWeek": "Gantt operativo personalizado por semana",
        "customMonth": "Gantt operativo personalizado por mes"
      },
      "modes": {
        "active": "planificaciones activas",
        "archived": "planificaciones archivadas"
      },
      "rangeLabel": " Del {{from}} al {{to}}.",
      "subtitles": {
        "day": "Vista por días calendario para revisar {{mode}}.{{rangeLabel}}",
        "week": "Vista por semanas operativas para revisar {{mode}}.{{rangeLabel}}",
        "quarter": "Vista trimestral agrupada por meses para revisar {{mode}}.{{rangeLabel}}",
        "semester": "Vista semestral agrupada por meses para revisar {{mode}}.{{rangeLabel}}",
        "year": "Vista anual agrupada por meses para revisar {{mode}}.{{rangeLabel}}",
        "month": "Vista agrupada por meses para revisar {{mode}}.{{rangeLabel}}"
      }
    },
    "calendar": {
      "weekLabel": "Sem {{number}}",
      "weekdaysShort": {
        "sun": "Dom",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mié",
        "thu": "Jue",
        "fri": "Vie",
        "sat": "Sáb"
      },
      "monthsShort": {
        "jan": "Ene",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Abr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ago",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dic"
      }
    },
    "modes": {
      "active": "Activas",
      "archived": "Archivadas"
    },
    "csv": {
      "id": "ID",
      "geofence": "Geocerca",
      "activity": "Actividad",
      "startDate": "Fecha inicio",
      "endDate": "Fecha fin",
      "plannedHours": "Horas planificadas",
      "plannedCost": "Costo planificado",
      "realHours": "Horas reales",
      "realCost": "Costo real",
      "hoursDifference": "Diferencia horas",
      "costDifference": "Diferencia costo",
      "trafficLight": "Semáforo",
      "trafficDetail": "Detalle semáforo",
      "status": "Estado",
      "notes": "Notas",
      "mode": "Modo",
      "exportDate": "Fecha exportación"
    },
    "validation": {
      "selectGeofence": "Selecciona una geocerca.",
      "selectActivity": "Selecciona una actividad.",
      "startDate": "Ingresa fecha de inicio.",
      "endDate": "Ingresa fecha de fin.",
      "invalidDates": "Formato de fechas inválido.",
      "endBeforeStart": "La fecha fin no puede ser anterior a la fecha inicio.",
      "plannedHours": "Ingresa horas planificadas.",
      "plannedHoursPositive": "Las horas deben ser un número mayor o igual a 0.",
      "plannedCost": "Ingresa costo planificado.",
      "plannedCostPositive": "El costo debe ser un número mayor o igual a 0.",
      "invalidStatus": "Estado inválido.",
      "reviewFields": "Revisa los campos marcados para continuar."
    },
    "alerts": {
      "completeRequired": "Completa los campos requeridos antes de guardar.",
      "noActiveOrg": "No hay organización activa para guardar planificación.",
      "saved": "Planificación guardada correctamente.",
      "updated": "Planificación actualizada correctamente.",
      "saveError": "No se pudo guardar la planificación.",
      "archived": "Planificación archivada correctamente.",
      "archiveError": "No se pudo archivar la planificación.",
      "restored": "Planificación restaurada correctamente.",
      "restoreError": "No se pudo restaurar la planificación."
    },
    "confirm": {
      "archive": "Archivar la planificación {{id}}? Esta acción la ocultará de la lista activa.",
      "restore": "Restaurar la planificación {{id}}? Volverá como borrador en la lista activa."
    },
    "errors": {
      "loadDb": "No se pudo cargar planificación desde Supabase. Mostrando demo local."
    },
    "fallbacks": {
      "unnamedGeofence": "Geocerca sin nombre",
      "unnamedActivity": "Actividad sin nombre",
      "undefinedGeofence": "Geocerca sin definir",
      "undefinedActivity": "Actividad sin definir",
      "geofencePrefix": "Geocerca",
      "activityPrefix": "Actividad"
    },
    "loading": {
      "fromSupabase": "Cargando planificación desde Supabase..."
    },
    "demo": {
      "campusNorth": "Campus Norte",
      "initialSurvey": "Levantamiento inicial",
      "perimeterMarking": "Marcación de perímetro"
    }
  },
  "personal": {
    "bannerCreated": "Personal creado exitosamente.",
    "bannerDeletedOk": "Registro eliminado correctamente.",
    "bannerEditMode": "Modo edición.",
    "bannerLoadingSession": "Cargando sesión…",
    "bannerLoginRequired": "Debes iniciar sesión para acceder a esta sección.",
    "bannerNewMode": "Modo creación de personal.",
    "bannerRefreshedOk": "Datos actualizados correctamente.",
    "bannerSelected": "Registro seleccionado.",
    "bannerUpdated": "Personal actualizado correctamente.",
    "buttonDelete": "Eliminar",
    "buttonEdit": "Editar",
    "buttonFullList": "Ver todo",
    "buttonNew": "Nuevo",
    "buttonRefresh": "Actualizar",
    "buttonSave": "Guardar",
    "confirmDelete": "¿Está seguro que desea eliminar este registro? (soft delete)",
    "errorDelete": "No se pudo eliminar el registro.",
    "errorDeleteNoRows": "No se pudo eliminar: el registro no existe o ya fue eliminado.",
    "errorLoad": "Error al cargar el personal.",
    "errorMissingEmail": "El correo es requerido.",
    "errorMissingName": "El nombre es requerido.",
    "errorMissingUser": "No se pudo obtener el usuario autenticado.",
    "errorMustSelectForDelete": "Debes seleccionar un registro para eliminarlo.",
    "errorMustSelectForEdit": "Debes seleccionar un registro para editarlo.",
    "errorNoAuthUser": "No existe un usuario autenticado.",
    "errorNoPermissionCreate": "No tienes permisos para crear personal.",
    "errorNoPermissionDelete": "No tienes permisos para eliminar personal.",
    "errorNoPermissionEdit": "No tienes permisos para editar personal.",
    "errorNoPermissionSave": "No tienes permisos para guardar cambios.",
    "errorPhonePolicy": "El teléfono debe comenzar con + (formato internacional E.164).",
    "errorSave": "No se pudo guardar el personal.",
    "errorSaveNoRecord": "No se recibió registro actualizado.",
    "fieldActive": "Activo",
    "fieldEmail": "Correo",
    "fieldLastName": "Apellido",
    "fieldName": "Nombre",
    "fieldPhonePlaceholder": "Teléfono (+593…)",
    "formTitleEdit": "Editar personal",
    "formTitleNew": "Nuevo personal",
    "no": "No",
    "onlyActive": "Solo activos",
    "orgFallback": "Sin organización",
    "orgInfoLabel": "Organización:",
    "pillCanEdit": "Editable",
    "pillReadOnly": "Solo lectura",
    "processing": "Procesando…",
    "roleLabel": "Rol:",
    "searchPlaceholder": "Buscar por nombre, apellido, correo o teléfono…",
    "table": {
      "columns": {
        "active": "Activo",
        "email": "Correo",
        "end": "Fin",
        "firstName": "Nombre",
        "lastName": "Apellido",
        "phone": "Teléfono",
        "start": "Inicio"
      },
      "loading": "Cargando…",
      "noActive": "No hay personal activo."
    },
    "tableActive": "Activo",
    "tableEmail": "Correo",
    "tableLastName": "Apellido",
    "tableName": "Nombre",
    "tableNoResults": "No se encontraron resultados.",
    "tablePhone": "Teléfono",
    "title": "Personal",
    "noActiveSession": "No hay sesión activa",
    "legacyTable": {
      "actions": "Acciones",
      "softDelete": "Eliminar (soft)",
      "todoEdit": "TODO: Editar"
    },
    "yes": "Sí"
  },
  "reportes": {
    "activityNoName": "Actividad sin nombre",
    "buttonDownloadCsv": "Descargar CSV",
    "colActividad": "Actividad",
    "colCosto": "Costo",
    "colFin": "Fin",
    "colGeocerca": "Geocerca",
    "colHoras": "Horas",
    "colInicio": "Inicio",
    "colMoneda": "Moneda",
    "colPersona": "Persona",
    "colTarifa": "Tarifa/hora",
    "csvHeaderActividad": "Actividad",
    "csvHeaderCosto": "Costo_total",
    "csvHeaderFin": "Fin",
    "csvHeaderGeocerca": "Geocerca",
    "csvHeaderHoras": "Horas",
    "csvHeaderInicio": "Inicio",
    "csvHeaderMoneda": "Moneda",
    "csvHeaderPersona": "Persona",
    "csvHeaderTarifa": "Tarifa_hora",
    "csvHeaderTotal": "Costo_total",
    "errorCsv": "No se pudo generar el archivo CSV.",
    "errorLabel": "Error:",
    "errorLoad": "Error al cargar los reportes.",
    "errorLoadFilters": "Error al cargar filtros (personas, actividades, geocercas).",
    "errorLoadReport": "Error al cargar el reporte de costos.",
    "errorRangeInvalid": "La fecha \"Desde\" no puede ser mayor que la fecha \"Hasta\".",
    "errorViewMissing": "La vista v_costos_detalle aún no está creada en Supabase.",
    "exportNoData": "No hay datos para exportar.",
    "filters": {
      "activityLabel": "Actividad",
      "apply": "Aplicar filtros",
      "clear": "Limpiar filtros",
      "dateFromLabel": "Desde",
      "dateToLabel": "Hasta",
      "geofenceLabel": "Geocerca",
      "personLabel": "Persona"
    },
    "filtersActivity": "Actividad",
    "filtersAll": "Todos",
    "filtersApply": "Aplicar filtros",
    "filtersClear": "Limpiar filtros",
    "filtersFrom": "Desde",
    "filtersGeofence": "Geocerca",
    "filtersPerson": "Persona",
    "filtersTitle": "Filtros",
    "filtersTo": "Hasta",
    "geofenceNoName": "Geocerca sin nombre",
    "headerSubtitle": "Consulta y exporta los costos por persona, actividad y geocerca.",
    "loadingReport": "Cargando reporte…",
    "noAccessBody": "No tienes permisos para visualizar los reportes de costos. Este módulo está disponible solo para propietarios y administradores.",
    "personNoName": "Persona sin nombre",
    "summaryRecordsHelp": "Cantidad de filas que cumplen con los filtros actuales.",
    "summaryRecordsLabel": "Registros",
    "summaryTotalCostHelp": "Suma de los costos calculados por persona, actividad y geocerca.",
    "summaryTotalCostLabel": "Costo total",
    "summaryTotalHoursHelp": "Suma de las horas de todas las asignaciones en el rango seleccionado.",
    "summaryTotalHoursLabel": "Horas totales",
    "table": {
      "activity": "Actividad",
      "currency": "Moneda",
      "end": "Fin",
      "geofence": "Geocerca",
      "hours": "Horas",
      "noResults": "No se encontraron registros para los filtros seleccionados.",
      "person": "Persona",
      "rate": "Tarifa/hora",
      "start": "Inicio",
      "title": "Detalle de costos",
      "total": "Costo total"
    },
    "tableEmpty": "No hay registros para los filtros seleccionados.",
    "tableExportButton": "Exportar CSV",
    "tableExportHelp": "Exporta el detalle actual como archivo CSV.",
    "tableTitle": "Detalle de costos",
    "title": "Reportes de costos"
  },
  "resetPassword": {
    "backHome": "Ir a la landing",
    "backToLogin": "Volver a iniciar sesión",
    "confirmPassword": "Confirmar contraseña",
    "confirmPlaceholder": "Repite",
    "invalidOrExpired": "El enlace de recuperación es inválido o expiró. Solicita uno nuevo.",
    "loading": "Preparando enlace de recuperación…",
    "newPassword": "Nueva contraseña",
    "newPasswordPlaceholder": "Mínimo 8 caracteres",
    "noSession": "No hay una sesión válida para restablecer la contraseña. Vuelve a solicitar una.",
    "noticeType": "Sesión detectada. Si este enlace no era de recuperación, vuelve a iniciar sesión normalmente.",
    "passwordMin": "La contraseña debe tener al menos 8 caracteres.",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "saveButton": "Guardar nueva contraseña",
    "saving": "Guardando…",
    "subtitle": "Crea una nueva contraseña para tu cuenta.",
    "success": "Contraseña actualizada correctamente. Ahora puedes iniciar sesión.",
    "tip": "Tip: vuelve a /inicio de sesión, escribe tu correo y usa \"¿Olvidaste tu contraseña?\" para generar un nuevo enlace.",
    "title": "Restablecer contraseña",
    "unexpected": "Ocurrió un error al preparar el restablecimiento de contraseña.",
    "updateFailed": "No se pudo actualizar la contraseña. Intenta nuevamente.",
    "updateUnexpected": "Error inesperado al actualizar la contraseña."
  },
  "tracker": {
    "page": {
      "title": "Tracker GPS"
    },
    "attendance": {
      "title": "Registro de asistencias",
      "noRecords": "Sin registros",
      "checkIn": "✅ Entrada",
      "checkOut": "🚪 Salida",
      "columns": {
        "user": "Usuario",
        "geofence": "Geocerca",
        "event": "Evento",
        "datetime": "Fecha y hora"
      }
    },
    "panel": {
      "title": "Panel del tracker",
      "statusActive": "Activo",
      "statusInactive": "Sin actividad",
      "lastUpdateRecent": "Última actualización reciente"
    },
    "gps": {
      "messageStarting": "Iniciando seguimiento...",
      "messagePreparing": "Preparando seguimiento...",
      "messageActive": "Seguimiento activo",
      "titleActive": "Seguimiento activo",
      "browserTitle": "Abre GeoField GPS para continuar",
      "browserSubtitle": "La sesión está preparada. Este navegador no puede iniciar el seguimiento de Android.",
      "browserBadge": "Seguimiento detenido",
      "openPreviewApp": "Abrir GeoField GPS Preview",
      "browserHelp": "Abre el enlace de invitación desde la app GeoField GPS instalada desde Google Play. El seguimiento solo puede iniciarse desde la app Android.",
      "browserHelpPreview": "Para esta prueba necesitas la versión Android configurada para Preview. Abre allí el enlace de invitación. La versión de producción no debe recibir esta sesión.",
      "sessionMissingTitle": "Sesión de seguimiento no disponible",
      "sessionMissingHelp": "No se están enviando posiciones. Abre tu invitación vigente para recuperar la sesión. Si fue revocada o caducó, solicita una nueva a tu administrador.",
      "titleStarting": "Iniciando seguimiento",
      "subtitleActive": "Tu ubicación se está compartiendo correctamente.",
      "subtitleStarting": "Estamos preparando tu sesión para comenzar el seguimiento.",
      "badgeActive": "Activo",
      "badgeInitializing": "Inicializando",
      "noteUpdated": "Estado actualizado correctamente.",
      "noteWait": "Esto puede tomar unos segundos."
    },
    "invite": {
      "title": "Permiso de ubicación",
      "intro": "GeoField GPS recopila y usa tu ubicación precisa con tu consentimiento para iniciar una sesión de tracking autorizada, compartirla con la organización que te invitó y validar recorridos, geocercas y reportes. El seguimiento puede funcionar en segundo plano o cuando la app no está visible. Puedes detener el seguimiento en cualquier momento o revocar el permiso de ubicación desde la configuración de tu dispositivo.",
      "introStep": {
        "before": "Lee y acepta el aviso destacado de ubicación antes de continuar.",
        "allow": "GeoField GPS recopila, usa y comparte tu ubicación precisa durante la sesión autorizada.",
        "after": " El seguimiento puede funcionar en segundo plano o cuando la app no está visible."
      },
      "consentLabel": "Entiendo y acepto que GeoField GPS recopile, use y comparta mi ubicación precisa con la organización que me invitó durante esta sesión de tracking autorizada, incluso cuando la app esté en segundo plano o no esté visible, para validar recorridos, geocercas y reportes operativos.",
      "acceptContinue": "Aceptar y continuar",
      "processing": "Procesando...",
      "permissionCardTitle": "Permitir el uso de ubicación",
      "permissionCardBody": {
        "before": "En el siguiente paso aparecerá el permiso del sistema para usar tu ubicación precisa. Toca",
        "after": "y permite el acceso en segundo plano para continuar."
      },
      "permissionAction": "Permitir el uso de ubicación",
      "requestingPermission": "Solicitando permiso...",
      "permissionAutoContinue": "Si el navegador muestra el permiso, solo confirma y el tracker continuará automáticamente.",
      "blockedTitle": "Necesitamos tu ubicación para continuar",
      "blockedBody": "La ubicación está bloqueada o el navegador no pudo mostrar el permiso. Debes habilitarla manualmente para seguir.",
      "inAppBrowserHint": {
        "before": "Estás dentro de Gmail o WhatsApp. Usa"
      },
      "chromePath": "Chrome → Configuración del sitio → Ubicación → Permitir",
      "statusLabel": "Estado",
      "errors": {
        "missingToken": "Invite token faltante.",
        "consentRequired": "Debes aceptar el consentimiento antes de continuar.",
        "blockedSite": "La ubicación está bloqueada para este sitio. Debes habilitarla manualmente para continuar.",
        "locationUnavailable": "No se pudo obtener la ubicación. Activa el GPS y vuelve a intentar.",
        "locationTimeout": "La ubicación tardó demasiado. Intenta de nuevo con mejor señal GPS.",
        "permissionFailed": "No se pudo obtener permiso de ubicación.",
        "blockedChrome": "La ubicación está bloqueada para este sitio. En Chrome: Ajustes del sitio → Ubicación → Permitir.",
        "locationUnavailableShort": "No se pudo obtener la ubicación."
      }
    },
    "history": {
      "traceLabel": "Rastro"
    },
    "controls": {
      "centerOnUser": "Centrar en mi posición",
      "refresh": "Refrescar posiciones",
      "showAll": "Mostrar todos",
      "showInside": "Solo dentro de geocercas"
    },
    "errorLoad": "Error al cargar las posiciones de tracker.",
    "legend": {
      "geofence": "Geocerca",
      "insideFence": "Dentro de geocerca",
      "outsideFence": "Fuera de geocerca"
    },
    "status": {
      "offline": "Sin datos recientes",
      "online": "Tracker en línea"
    },
    "subtitle": "Visualiza en tiempo real la ubicación de los trackers dentro de tus geocercas.",
    "table": {
      "activity": "Actividad",
      "geofence": "Geocerca",
      "noResults": "No hay posiciones registradas.",
      "person": "Persona",
      "status": "Estado",
      "timestamp": "Fecha/hora",
      "title": "Últimas posiciones"
    },
    "title": "Tracker GPS"
  },
  "table": {
    "name": "Nombre",
    "status": "Estado",
    "lastPosition": "Última posición",
    "lastUpdate": "Última actualización"
  },
  "status": {
    "online": "En línea",
    "stale": "Desactualizado",
    "offline": "Sin conexión"
  },
  "map": {
    "coordinates": "Coordenadas",
    "lat": "Lat",
    "lng": "Lng",
    "legend": "Leyenda"
  },
  "trackerDashboard": {
    "title": "Panel de seguimiento",
    "timeWindows": {
      "1h": "1 hora",
      "6h": "6 horas",
      "12h": "12 horas",
      "24h": "24 horas"
    },
    "sections": {
      "filters": "Filtros",
      "diagnostics": "Diagnóstico",
      "map": "Mapa"
    },
    "labels": {
      "window": "Ventana",
      "tracker": "Tracker",
      "geofences": "Geocercas",
      "all": "Todos",
      "activeOrg": "Org activa",
      "activeOrgDebug": "Org (Activa)",
      "detectedPlan": "Plan detectado"
    },
    "actions": {
      "resolveOrgAgain": "Re-resolver org (RPC)",
      "refresh": "Actualizar",
      "loading": "Cargando…",
      "centerGeofence": "Centrar geocerca"
    },
    "states": {
      "validatingPlan": "Validando plan de la organización...",
      "planValidationFailed": "No se pudo validar el plan de la organización.",
      "moduleUnavailable": "Este módulo no está disponible en el plan actual de la organización.",
      "requiresPro": "El panel de seguimiento no está habilitado para esta organización.",
      "upgradeHint": "Revisa el estado del plan y el cupo de trackers de la organización.",
      "upgradeOrgPrompt": "Gestiona el plan de la organización para revisar el acceso.",
      "resolvingActiveOrg": "Resolviendo organización activa…"
    },
    "messages": {
      "loadAssignmentsError": "Error cargando asignaciones (tracker_assignments).",
      "loadGeofencesError": "Error al cargar geocercas.",
      "loadPositionsError": "Error al cargar posiciones.",
      "noActiveAssignments": "No hay asignaciones activas (tracker_assignments). Mostrando todas las geocercas activas (la default queda preseleccionada).",
      "noActiveGeofencesForAssignments": "Hay asignaciones, pero no hay geocercas activas para esas asignaciones en la org ({{orgId}}).",
      "fallbackGeofenceShown": "No se encontraron geocercas activas; se mostró 1 geocerca activa como fallback para no dejar el panel vacío.",
      "noActiveGeofencesForOrg": "No hay geocercas activas disponibles para esta org ({{orgId}}).",
      "noVisibleGeofences": "No hay geocercas activas/visibles disponibles para esta org (o no tienes permiso de verlas).",
      "orgResolveError": "Error resolviendo org"
    },
    "badges": {
      "assignments": "assignments",
      "trackers": "trackers",
      "geofences": "geocercas",
      "polys": "polys",
      "circles": "circles",
      "positions": "posiciones",
      "source": "src",
      "assignedIds": "assignedIds",
      "selected": "selected",
      "bounds": "bounds",
      "viewport": "viewport",
      "intersects": "intersects"
    },
    "map": {
      "initializing": "Inicializando mapa…",
      "statusPrefix": "map",
      "circleLabel": "{{name}} (círculo)"
    },
    "tooltip": {
      "tracker": "Tracker",
      "time": "Hora",
      "lat": "Lat",
      "lng": "Lng",
      "accuracy": "Acc",
      "speed": "Vel",
      "source": "Src"
    },
    "multiGeofence": {
      "labelBase": "Geocercas",
      "labelNone": "Geocercas: Ninguna",
      "labelAll": "Geocercas: Todas ({{count}})",
      "labelSelected": "Geocercas: {{count}}",
      "searchPlaceholder": "Buscar geocerca…",
      "showAll": "Mostrar todas",
      "hideAll": "Ocultar todas",
      "noResults": "Sin resultados…",
      "close": "Cerrar"
    }
  },
  "trackerGps": {
    "title": "Tracker GPS",
    "lastSend": "Último envío",
    "waitingCoords": "Esperando coordenadas…",
    "debugCopyPaste": "Debug (copiar/pegar)",
    "stateLabel": "Estado",
    "onlyInvited": "Esta página es solo para trackers invitados.",
    "goHome": "Ir al inicio",
    "status": {
      "initializing": "Iniciando tracker…",
      "processingMagicLink": "Procesando Magic Link del Tracker…",
      "sessionOkPreparing": "Sesión OK. Preparando tracker…",
      "readingSession": "Leyendo sesión del tracker…",
      "noSession": "No hay una sesión activa del tracker.",
      "noGeolocation": "Este dispositivo no soporta geolocalización.",
      "active": "Tracker activo",
      "activating": "Activando tracker en la organización…",
      "noPermission": "Tracker sin permiso / onboarding",
      "gpsError": "Error de GPS"
    },
    "errors": {
      "notConfigured": "El tracker no está configurado en este deployment.",
      "noSupabaseClient": "No se encontró el cliente principal de Supabase.",
      "setSession": "Error en setSession:",
      "hashSession": "Error de sesión por hash:",
      "openFromMagicLinkOnly": "Abre esta página solo desde tu Magic Link de Tracker.",
      "geolocationUnavailable": "Geolocalización no disponible."
    },
    "membership": {
      "missingOrgId": "Falta org_id en la URL. Abre esta página desde el link de invitación: /tracker-gps?org_id=<ORG_ID>.",
      "checking": "Verificando membresía…",
      "noValidTokenUser": "No hay token/usuario válido en /tracker-gps.",
      "okSessionCache": "Membresía OK (cache de sesión).",
      "membershipsSelectError": "Error en select de memberships:",
      "alreadyExists": "La membresía ya existe: role={{role}}",
      "runningAccept": "No existe membresía. Ejecutando accept-tracker-invite",
      "acceptError": "Error de accept-tracker-invite:",
      "membershipsRecheckError": "Error de revalidación de memberships:",
      "acceptReturnedButNotCreated": "accept-tracker-invite devolvió OK pero la membresía no fue creada.",
      "acceptOk": "accept-tracker-invite OK.",
      "onboardingException": "Excepción en onboarding:"
    },
    "disclosure": {
      "title": "Ubicación en segundo plano",
      "body1": "GeoField GPS recopila tu ubicación incluso cuando la app esté cerrada o el teléfono bloqueado para registrar posiciones y validar entrada y salida de geocercas durante la jornada laboral.",
      "body2": "Esta información se utiliza únicamente para fines operativos de la organización y no se comparte con terceros ni se usa para publicidad. Puedes detener el seguimiento revocando el permiso de ubicación o cerrando sesión.",
      "continue": "Continuar"
    },
    "debugLabels": {
      "send": "send",
      "accept": "accept",
      "orgId": "org_id",
      "membership": "membership",
      "tokenIss": "token_iss",
      "tokenTtlSec": "token_ttl_sec",
      "lastHttpStatus": "last_http_status",
      "lat": "lat",
      "lng": "lng",
      "acc": "acc"
    },
    "perms": {
      "panelTitle": "Permisos críticos del tracker",
      "panelDesc": "Para que GeoField GPS siga funcionando después de reiniciar el móvil o dejarlo en reposo, activa estos permisos críticos.",
      "locationAlways": "Ubicación siempre",
      "locationAlwaysAlert": "Activa ubicación SIEMPRE: Ajustes > Apps > GeoField GPS > Permisos > Ubicación > Permitir siempre.",
      "batteryUnrestricted": "Batería sin restricción",
      "batteryUnrestrictedAlert": "Activa batería sin restricciones: Ajustes > Apps > GeoField GPS > Batería > Sin restricciones o No optimizar.",
      "autostart": "Autoinicio",
      "autostartAlert": "Activa autoinicio: Ajustes / Phone Master / Power Center > Auto-start management > GeoField GPS > Permitir.",
      "backgroundData": "Datos en segundo plano",
      "backgroundDataAlert": "Permite actividad y datos en segundo plano: Ajustes > Apps > GeoField GPS > Datos móviles / Batería > Permitir segundo plano."
    }
  },
  "pricing": {
    "accessDenied": "No tienes permisos para ver monetización en esta organización.",
    "common": {
      "currentPlan": "Plan actual",
      "loading": "Cargando...",
      "notAvailable": "—",
      "unlimited": "Ilimitadas"
    },
    "actions": {
      "goToBilling": "Ir a Facturación",
      "contactSales": "Contactar ventas"
    },
    "page": {
      "title": "Planes y precios",
      "previewNotice": {
        "prefix": "Esta pantalla trabaja en",
        "previewTag": "PREVIEW",
        "middle": "y usa el flujo de suscripción en modo",
        "testTag": "TEST",
        "suffix": "No afecta producción."
      }
    },
    "summary": {
      "detectedPlan": "Plan detectado",
      "noCommercialData": "Sin datos comerciales",
      "status": "Estado",
      "trialUntil": "Prueba hasta",
      "planCodes": {
        "free": "FREE",
        "pro": "PRO",
        "enterprise": "ENTERPRISE"
      },
      "planCodeUnknown": "{{code}}",
      "maxGeofences": "Máx. geocercas",
      "maxTrackers": "Máx. trackers"
    },
    "free": {
      "title": "Free",
      "subtitle": "Para comenzar",
      "price": "$0",
      "description": "Pensado para validar el uso inicial de la plataforma.",
      "currentPlanMessage": "Ya estás usando el plan Free.",
      "features": {
        "validateFlow": "Ideal para empezar y validar el flujo base",
        "upToTrackers": "Hasta {{count}} tracker",
        "geofenceLimits": "Geocercas con límite por plan",
        "billingAndUpgrade": "Acceso a Facturación y futura ruta de mejora de plan",
        "backendEnforcement": "Backend sigue aplicando enforcement real"
      }
    },
    "pro": {
      "title": "Pro",
      "subtitle": "Operación SaaS activa",
      "price": "Pro",
      "description": "Plan recomendado para habilitar el módulo Tracker y operar con suscripción.",
      "higherPlanMessage": "Tu organización ya tiene un plan superior o distinto de Free.",
      "reviewBillingMessage": "Revisa Facturación para administrarlo.",
      "features": {
        "upToTrackers": "Hasta {{count}} trackers por organización",
        "upToGeofences": "Hasta {{count}} geocercas",
        "trackerEnabled": "Módulo Tracker habilitado",
        "invitesEnabled": "Invitación de trackers habilitada",
        "stripeSelfManaged": "Suscripción autogestionable"
      }
    },
    "enterprise": {
      "title": "Enterprise",
      "subtitle": "Venta asistida",
      "description": "Para organizaciones que requieren condiciones comerciales especiales.",
      "features": {
        "salesOnboarding": "Atención comercial y onboarding guiado",
        "flexibleLimits": "Límites y condiciones ajustables",
        "multiTeamReady": "Preparado para operación con múltiples equipos",
        "specialAgreements": "Escalamiento comercial y acuerdos especiales",
        "directSalesContact": "Contacto directo con ventas"
      }
    },
    "notes": {
      "title": "Notas de esta fase",
      "backendAuthority": "El backend sigue siendo la autoridad real del plan. Esta página solo refleja el plan y muestra las acciones comerciales disponibles.",
      "proCheckout": "La mejora a Pro usa checkout seguro. Administra tu suscripción desde Facturación.",
      "enterpriseSales": "Enterprise queda presentado como canal comercial, sin activar checkout automático."
    },
    "status": {
      "active": "Activo",
      "trialing": "Prueba",
      "past_due": "Pago vencido",
      "canceled": "Cancelado",
      "paused": "Pausado",
      "incomplete": "Incompleto",
      "other": "Estado: {{status}}"
    }
  },
  "billing": {
    "errors": {
      "loadPlanStatus": "No se pudo cargar el estado del plan."
    },
    "cancel": {
      "title": "Checkout cancelado",
      "subtitle": "No se realizó ningún cobro.",
      "backToBilling": "Volver a Billing",
      "goHome": "Ir a Inicio"
    },
    "title": "Facturación",
    "authRequired": "Inicia sesión para administrar tu plan.",
    "previewNotice": {
      "prefix": "Monetización en",
      "middle": "(Flujo de suscripción).",
      "suffix": "No afecta producción."
    },
    "actions": {
      "viewPlans": "Ver planes"
    },
    "labels": {
      "email": "Correo",
      "orgId": "ID de organización"
    },
    "planState": {
      "title": "Estado del plan"
    },
    "states": {
      "loadingPlanStatus": "Cargando estado del plan..."
    },
    "cards": {
      "currentPlan": "Plan actual",
      "status": "Estado",
      "trialUntil": "Prueba hasta",
      "currentPeriodUntil": "Periodo actual hasta"
    },
    "subscriptionManagement": {
      "title": "Gestión de suscripción",
      "description": "Abre Facturación para gestionar los detalles de tu suscripción.",
      "cancelRenewal": "Cancelar renovación",
      "confirmCancelRenewal": "Esto cancelará la renovación automática. Tu plan permanecerá activo hasta el final del periodo de facturación actual. ¿Deseas continuar?",
      "cancelingRenewal": "Cancelando renovación...",
      "renewalCanceled": "Renovación cancelada. El plan permanecerá activo hasta el final del periodo de facturación.",
      "cancelRenewalError": "No se pudo cancelar la renovación."
    },
    "messages": {
      "cancelAtPeriodEnd": "Tu suscripción está configurada para cancelarse al final del periodo actual.",
      "activePlanExists": "Ya existe un plan activo para esta organización. El botón de actualización no se muestra."
    },
    "upgrade": {
      "productTitle": "Geocercas PRO",
      "orgIdLabel": "Org ID",
      "notResolved": "(no resuelta)",
      "organizationInputLabel": "Organization ID (org_id)",
      "organizationInputPlaceholder": "Ej: ea4f7ebc-651a-48b9-9ac3-b0bdbee1db9a",
      "organizationInputHelp": "Si no se detecta automáticamente, pega aquí el UUID de la organización.",
      "subscribe": "Suscribirme a PRO",
      "processing": "Procesando...",
      "noticeTitle": "Aviso",
      "messages": {
        "paddleError": "ERROR DEL PROVEEDOR DE PAGOS:\n{{details}}",
        "checkoutUrlMissing": "FALTA CHECKOUT URL:\n{{details}}",
        "paddleException": "EXCEPCION DEL PROVEEDOR DE PAGOS:\n{{details}}"
      },
      "errors": {
        "invalidOrgId": "Org ID inválido. Copia el Organization ID (UUID) y pégalo aquí."
      }
    },
    "compareBeforeUpgrade": {
      "title": "¿Quieres comparar antes de actualizar?",
      "description": "Revisa la página de planes para comparar Free, Pro y Enterprise."
    },
    "status": {
      "trialing": "Prueba",
      "active": "Activo",
      "pastDue": "Pago vencido",
      "canceled": "Cancelado",
      "free": "Gratis"
    }
  },
  "reports": {
    "title": "Reportes",
    "currentOrg": "Org actual",
    "sessionLoading": "Cargando tu sesión…",
    "noActiveSession": "No hay sesión activa. Inicia sesión nuevamente.",
    "noActiveOrg": "No hay organización activa para este usuario.",
    "filters": {
      "title": "Filtros",
      "subtitle": "Selecciona rangos y listas. Luego presiona Generar.",
      "reloadLists": "Recargar listas",
      "reloadFilters": "Recargar filtros",
      "clearSelections": "Limpiar selecciones",
      "clearSelectionsTitle": "Limpiar selecciones (no borra fechas)",
      "from": "Desde",
      "to": "Hasta",
      "generate": "Generar",
      "generating": "Generando…",
      "exportCsv": "Exportar CSV",
      "tipLabel": "Tip:",
      "tipMultiSelect": "En listas multi-select usa Ctrl (Windows) / Command (Mac) para seleccionar múltiples.",
      "geofences": "Geocercas",
      "people": "Personas",
      "activities": "Actividades",
      "assignments": "Asignaciones",
      "multi": "(multi)",
      "assignmentFallback": "asignación",
      "assignmentNote": "Nota: si tus asignaciones no tienen personal_id, el cruce con marcajes puede salir vacío."
    },
    "results": {
      "title": "Resultados",
      "generating": "Generando reporte…",
      "rows": "Filas: {{count}}",
      "emptyHint": "Aún no hay datos. Ajusta filtros y genera.",
      "loading": "Cargando…",
      "noDataSelectedFilters": "No hay datos con los filtros seleccionados."
    },
    "table": {
      "day": "Día",
      "person": "Persona",
      "email": "Correo",
      "geofence": "Geocerca",
      "activity": "Actividad",
      "assignment": "Asignación",
      "entry": "Entrada",
      "exit": "Salida",
      "marks": "Marcajes",
      "inside": "Dentro",
      "distanceM": "Dist (m)",
      "rate": "Tarifa",
      "dash": "—"
    },
    "errors": {
      "loadFilters": "Error cargando filtros.",
      "noActiveOrgOrSession": "No hay organización activa o la sesión no está lista.",
      "invalidDateRange": "La fecha \"Desde\" no puede ser mayor que la fecha \"Hasta\".",
      "generateReport": "Error generando reporte.",
      "exportNoData": "No hay datos para exportar."
    }
  },
  "activityAssignments": {
    "title": "Asignación de actividades",
    "subtitle": "Define qué actividad realiza cada persona en un rango de fechas. La misma persona no puede tener dos actividades al mismo tiempo.",
    "session": "Sesión",
    "actions": {
      "new": "+ Nueva asignación",
      "refresh": "Refrescar",
      "edit": "Editar",
      "delete": "Eliminar",
      "clear": "Limpiar",
      "newShort": "Nueva",
      "saveChanges": "Guardar cambios",
      "createAssignment": "Crear asignación",
      "saving": "Guardando..."
    },
    "filters": {
      "trackerPerson": "Tracker / Persona",
      "activity": "Actividad",
      "startFrom": "Inicio desde",
      "endUntil": "Fin hasta",
      "allTrackers": "Todos",
      "allActivities": "Todas"
    },
    "table": {
      "title": "Listado de asignaciones",
      "loading": "Cargando...",
      "person": "Persona",
      "activity": "Actividad",
      "start": "Inicio",
      "end": "Fin",
      "actions": "Acciones",
      "empty": "No hay asignaciones para los filtros actuales."
    },
    "form": {
      "titleCreate": "Nueva asignación",
      "titleEdit": "Editar asignación",
      "titleView": "Detalles / nueva asignación",
      "trackerPerson": "Persona / Tracker",
      "activity": "Actividad",
      "startDate": "Fecha inicio",
      "endDateOptional": "Fecha fin (opcional)",
      "selectOption": "Seleccione..."
    },
    "messages": {
      "initialLoadError": "Error al cargar datos iniciales",
      "activitiesLoadError": "No se pudieron cargar las actividades",
      "trackersLoadError": "No se pudieron cargar los trackers",
      "assignmentsLoadError": "No se pudieron cargar las asignaciones",
      "requiredFields": "Tracker, actividad y fecha de inicio son obligatorios",
      "assignedSuccessfully": "Actividad asignada correctamente",
      "updatedSuccessfully": "Asignación actualizada correctamente",
      "invalidFormMode": "Modo de formulario inválido",
      "constraintOverlap": "No se puede asignar esta actividad: la persona ya tiene otra actividad en ese rango de fechas.",
      "saveError": "Error al guardar la asignación de actividad",
      "deletedSuccessfully": "Asignación eliminada correctamente",
      "deleteError": "No se pudo eliminar la asignación de actividad"
    },
    "overlap": {
      "selectedPerson": "seleccionada",
      "otherActivity": "otra actividad",
      "noEndDate": "sin fecha de fin",
      "message": "La persona {{person}} ya tiene asignada la actividad \"{{activity}}\" entre {{start}} y {{end}}."
    },
    "confirmDelete": "¿Seguro que deseas eliminar la asignación de \"{{activity}}\" para \"{{tracker}}\"?",
    "fallbacks": {
      "activity": "actividad",
      "tracker": "tracker"
    }
  },
  "admin": {
    "dashboard": {
      "title": "Panel de Administración",
      "configRequired": "Configuración requerida",
      "modules": {
        "geocercas": "Geocercas",
        "geocercasV2": "Geocercas V2",
        "personal": "Personal",
        "reports": "Reportes"
      },
      "modulesDescriptions": {
        "geocercas": "Gestiona las geocercas de tu organización",
        "geocercasV2": "Geocercas mejoradas con nueva interfaz",
        "personal": "Gestiona el personal de campo",
        "reports": "Consulta reportes y eventos"
      },
      "logout": "Cerrar sesión"
    },
    "geocercasV2": {
      "title": "Geocercas",
      "showAll": "Mostrar todas",
      "back": "← Volver",
      "savedGeofencesHeader": "Geocercas guardadas",
      "loading": "Cargando...",
      "noGeofences": "No hay geocercas",
      "status": {
        "active": "Activa",
        "inactive": "Inactiva"
      },
      "actions": {
        "view": "Ver",
        "deactivate": "Desactivar",
        "activate": "Activar",
        "edit": "Editar",
        "editInMap": "Editar en mapa",
        "delete": "Eliminar"
      },
      "floatingActions": {
        "save": "Guardar",
        "cancel": "Cancelar"
      },
      "prompt": {
        "name": "Nombre de la geocerca:",
        "newName": "Nuevo nombre (deja igual si no quieres cambiar):",
        "editCoords": "Edita coordenadas (lat,lng por línea). Deja en blanco para mantener:"
      },
      "manualForm": {
        "title": "Crear geocerca manualmente",
        "hintFormat": "Formato: lat,lng por línea. Mínimo 3 líneas.",
        "saveButton": "Guardar manual"
      },
      "labels": {
        "personal": "Personal:",
        "assignments": "Asignaciones:"
      },
      "mapControls": {
        "latLngTip": "Mover cursor para ver Lat/Lng"
      }
    },
    "usersRoles": {
      "title": "Usuarios y Roles",
      "processing": "Procesando…",
      "inviteSection": "Invitar usuario",
      "emailPlaceholder": "correo@dominio.com",
      "fullNamePlaceholder": "Nombre completo",
      "fullNameLabel": "Nombre completo",
      "roleOwner": "OWNER",
      "inviteButton": "Invitar",
      "pendingInvitesTitle": "Invitaciones pendientes",
      "noPending": "No hay invitaciones.",
      "usersTitle": "Usuarios",
      "noUsers": "No hay usuarios registrados.",
      "table": {
        "email": "Correo",
        "name": "Nombre",
        "role": "Rol",
        "date": "Fecha",
        "actions": "Acciones",
        "newRole": "Nuevo Rol"
      },
      "magicLink": "Magic Link",
      "deleteButton": "Eliminar",
      "assignButton": "Asignar",
      "confirmDelete": "¿Eliminar/suspender a {{correo}}?",
      "inviteSuccess": "Invitación enviada a {{correo}}",
      "assignSuccess": "Rol \"{{role}}\" asignado a {{correo}}",
      "magicLinkSentInvite": "Invitación enviada a {{correo}}",
      "magicLinkSentLink": "Enlace mágico enviado a {{correo}}",
      "deleteSuccess": "Usuario {{correo}} eliminado/suspendido"
    },
    "geofences": {
      "errors": {
        "loadFailed": "No se pudo cargar la lista",
        "invalidPolygon": "Dibuja un polígono válido.",
        "saveFailed": "Error al guardar",
        "invalidInput": "Revisa nombre y al menos 3 coordenadas válidas.",
        "createFailed": "No se pudo guardar la geocerca",
        "statusChangeFailed": "No se pudo cambiar estado",
        "deleteFailed": "No se pudo eliminar",
        "noCoordinates": "Geocerca sin coordenadas válidas",
        "minimumPoints": "Se requieren al menos 3 puntos válidos.",
        "editFailed": "No se pudo editar",
        "invalidCoordinates": "Coordenadas inválidas.",
        "invalidPolygonData": "Polígono inválido."
      },
      "messages": {
        "created": "✅ Geocerca guardada.",
        "createdManual": "Geocerca creada (manual).",
        "activated": "✅ Activada",
        "deactivated": "✅ Desactivada",
        "deleted": "🗑️ Eliminada.",
        "updated": "✏️ Geocerca actualizada.",
        "mapEditActive": "🟠 Edición en mapa activa. Ajusta vértices y pulsa 'Guardar cambios'.",
        "editCancelled": "Edición cancelada.",
        "changesSaved": "✅ Cambios guardados."
      },
      "confirmDelete": "¿Eliminar \"{{name}}\"?"
    }
  },
  "trackerPanel": {
    "title": "Panel del Tracker",
    "description": "Aquí verás tus geocercas asignadas, tu estado (dentro/fuera) y podrás reportar incidencias.",
    "logout": "Cerrar sesión"
  },
  "mapaTracking": {
    "traceLabel": "Rastro:",
    "timeWindows": {
      "15min": "15 min",
      "30min": "30 min",
      "60min": "60 min"
    },
    "refresh": "Refrescar",
    "loading": "Cargando…"
  },
  "newOrg": {
    "title": "Nueva organización",
    "labels": {
      "name": "Nombre",
      "slug": "Slug (opcional)"
    },
    "placeholders": {
      "name": "Ej. Finca Principal",
      "slug": "ej. mi-finca-principal"
    },
    "buttons": {
      "create": "Crear",
      "cancel": "Cancelar"
    }
  },
  "geofenceForm": {
    "title": "Nueva geocerca",
    "fields": {
      "name": "Nombre",
      "coordinates": "Coordenadas",
      "onePerLine": "por línea"
    },
    "placeholders": {
      "name": "Ej. Campo 1",
      "example": "-0.1807, -78.4678"
    },
    "labels": {
      "name": "Nombre",
      "coordinates": "Coordenadas (lat,lng por línea)"
    },
    "actions": {
      "save": "Guardar geocerca",
      "saving": "Guardando..."
    },
    "hints": {
      "mapSelection": "Dibuja o selecciona en el mapa; si la caja está vacía, ese polígono será usado."
    },
    "map": {
      "lat": "Lat",
      "lng": "Lng",
      "movePointer": "Mueve el puntero sobre el mapa…"
    },
    "errors": {
      "minPoints": "Se requieren al menos 3 puntos."
    },
    "fallbacks": {
      "unnamed": "Sin nombre"
    },
    "messages": {
      "saved": "Geocerca guardada correctamente.",
      "errorPrefix": "Error",
      "created": "Geocerca creada correctamente.",
      "createError": "Error al crear geocerca",
      "updated": "Geocerca(s) actualizada(s) correctamente.",
      "updateError": "Error al actualizar geocerca",
      "deleted": "Geocerca(s) eliminada(s) correctamente.",
      "deleteError": "Error al eliminar geocerca"
    }
  },
  "geofences": {
    "labels": {
      "personal": "Personal:",
      "assignments": "Asignaciones:"
    },
    "actions": {
      "links": "Vínculos"
    }
  },
  "benchmarking": {
    "header": {
      "badge": "Mejora continua",
      "title": "Benchmarking",
      "subtitle": "Compara eficiencia operativa entre asignaciones, geocercas, personas o actividades usando horas/m² y $/m²."
    },
    "actions": {
      "refresh": "Actualizar",
      "exportCsv": "Exportar CSV",
      "resetFilters": "Limpiar filtros"
    },
    "alerts": {
      "plannedOnlyTitle": "Datos planificados.",
      "plannedOnlyBody": "La vista actual no tiene horas de tracking vinculadas a asignaciones. Benchmarking usa horas planificadas y lo indica como fuente PLANIFICADA."
    },
    "filters": {
      "all": "Todos",
      "geofence": "Geocerca",
      "person": "Persona / trabajador",
      "activity": "Actividad",
      "dateFrom": "Desde",
      "dateTo": "Hasta",
      "period": "Periodo agrupado",
      "compareBy": "Comparar por",
      "indicator": "Indicador",
      "chartType": "Tipo de gráfico",
      "title": "Filtros",
      "subtitle": "Ajusta la vista para comparar eficiencia operativa."
    },
    "periods": {
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "quarter": "Trimestre",
      "semester": "Semestre",
      "year": "Año"
    },
    "compareBy": {
      "assignment": "Asignaciones",
      "geofence": "Geocercas",
      "person": "Personas",
      "activity": "Actividades"
    },
    "indicators": {
      "horas_m2": "Horas/m²",
      "costo_m2": "$/m²"
    },
    "chartTypes": {
      "bars": "Barras",
      "lines": "Líneas"
    },
    "kpis": {
      "best": "Mejor eficiencia",
      "worst": "Peor eficiencia",
      "average": "Promedio general",
      "totalDifference": "Diferencia acumulada total",
      "totalDifferenceHint": "Suma de diferencias contra promedio",
      "optimizableCost": "Costo potencialmente optimizable",
      "optimizableCostHint": "Exceso vs promedio",
      "optimizableHours": "Horas potencialmente optimizables",
      "optimizableHoursHint": "Exceso vs promedio"
    },
    "chart": {
      "title": "Visualización",
      "subtitle": "Barras comparan grupos; líneas muestran evolución temporal promedio."
    },
    "table": {
      "title": "Tabla comparativa",
      "subtitle": "Las alertas muestran desviación contra el promedio visible; no toman decisiones automáticas.",
      "rows": "{{count}} filas",
      "signal": "Semáforo",
      "geofence": "Geocerca",
      "person": "Persona",
      "activity": "Actividad",
      "period": "Periodo",
      "areaM2": "Área m²",
      "areaReadable": "Área legible",
      "observedHours": "Horas observadas",
      "plannedHours": "Horas planificadas",
      "costBase": "Costo base",
      "costFinal": "Costo final auditado",
      "hoursM2": "Horas/m²",
      "costM2": "$/m²",
      "diffAverage": "Diferencia contra promedio",
      "cumulativeDiff": "Diferencia acumulada",
      "evidence": "Fuente",
      "opportunity": "Oportunidad de mejora"
    },
    "traffic": {
      "green": "Verde",
      "yellow": "Amarillo",
      "red": "Rojo",
      "gray": "Sin datos"
    },
    "opportunities": {
      "green": "Mantener estándar y usar como referencia",
      "yellow": "Revisar desviación moderada",
      "red": "Priorizar análisis operativo",
      "gray": "Completar datos antes de comparar"
    },
    "evidence": {
      "TRACKING": "Tracking",
      "PLANIFICADA": "Planificada",
      "MIXTA": "Mixta"
    },
    "fallbacks": {
      "geofence": "Geocerca sin nombre",
      "person": "Persona sin nombre",
      "activity": "Actividad sin nombre"
    },
    "labels": {
      "multiple": "Varias"
    },
    "empty": {
      "chart": "No hay suficientes datos para graficar.",
      "table": "No hay datos de benchmarking con los filtros actuales."
    },
    "errors": {
      "load": "No se pudo cargar benchmarking."
    },
    "loading": "Cargando benchmarking...",
    "csv": {
      "title": "Benchmarking operativo",
      "exportedAt": "Fecha de exportación"
    }
  },
  "plans100": {
    "catalogLimits": "Hasta {{trackers}} trackers y {{geofences}} geocercas",
    "subscribe": "Suscribirse a ENTERPRISE 100",
    "upgrade": "Subir a ENTERPRISE 100",
    "maximum": "Tu organización ya tiene el plan máximo (ENTERPRISE 100).",
    "description": "Para operaciones con hasta 100 trackers.",
    "limits": "Hasta 100 trackers y 250 geocercas",
    "confirmTitle": "Confirmar cambio a {{plan}}",
    "confirmBody": "Tu suscripción actual cambiará al plan {{plan}}. El proveedor aplicará el prorrateo correspondiente con el método de pago existente. No se creará una segunda suscripción.",
    "alreadyActive": "Tu organización ya tiene este plan o uno superior."
  }
}
